import React, { useState, useMemo, useRef, useCallback, useEffect } from "react";

const SD = {
  AL:{name:"Alabama",ip:10,ron:10,nf:false,note:"$10 max per act. No cap on travel fees."},
  AK:{name:"Alaska",ip:null,ron:null,nf:true,note:"No set fee — disclose rate in advance."},
  AZ:{name:"Arizona",ip:10,ron:10,nf:false,note:"$10 per notary signature. Must inform signer of fees."},
  AR:{name:"Arkansas",ip:null,ron:null,nf:true,note:"No set fee — must disclose before appointment."},
  CA:{name:"California",ip:15,ron:null,nf:false,note:"$15 per signature. RON fee — check CA SOS."},
  CO:{name:"Colorado",ip:15,ron:25,nf:false,note:"$15 in-person; $25 per notary signature for RON."},
  CT:{name:"Connecticut",ip:5,ron:5,nf:false,note:"$5 max per notarial act."},
  DE:{name:"Delaware",ip:5,ron:25,nf:false,note:"$5 in-person; $25 for RON."},
  DC:{name:"Washington D.C.",ip:5,ron:25,nf:false,note:"$5 in-person; $25 for RON."},
  FL:{name:"Florida",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON."},
  GA:{name:"Georgia",ip:2,ron:null,nf:false,note:"$2 max per act. RON not authorized. Must display fee schedule."},
  HI:{name:"Hawaii",ip:5,ron:25,nf:false,note:"$5 per signer; $25 for RON."},
  ID:{name:"Idaho",ip:5,ron:null,nf:false,note:"$5 max per act."},
  IL:{name:"Illinois",ip:5,ron:25,nf:false,note:"$5 in-person; $25 for RON."},
  IN:{name:"Indiana",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON."},
  IA:{name:"Iowa",ip:null,ron:null,nf:true,note:"No set fee schedule."},
  KS:{name:"Kansas",ip:null,ron:null,nf:true,note:"No set fee — must inform signer in advance."},
  KY:{name:"Kentucky",ip:null,ron:null,nf:true,note:"No set fee — disclose before appointment."},
  LA:{name:"Louisiana",ip:null,ron:null,nf:true,note:"No set fee. Market rate applies."},
  ME:{name:"Maine",ip:null,ron:null,nf:true,note:"No set fee — must inform signer in advance."},
  MD:{name:"Maryland",ip:8,ron:30,nf:false,note:"$8 in-person; $30 for RON."},
  MA:{name:"Massachusetts",ip:null,ron:null,nf:true,note:"No statutory maximum."},
  MI:{name:"Michigan",ip:10,ron:10,nf:false,note:"$10 max per act. Must advise clients of fees."},
  MN:{name:"Minnesota",ip:5,ron:null,nf:false,note:"$5 max per act."},
  MS:{name:"Mississippi",ip:5,ron:null,nf:false,note:"$5 max per act."},
  MO:{name:"Missouri",ip:5,ron:5,nf:false,note:"$5 in-person; $5 + RON transaction fee for RON. Must display fees."},
  MT:{name:"Montana",ip:10,ron:10,nf:false,note:"$10 in-person; $10 + technology fee for RON. Must display fees."},
  NE:{name:"Nebraska",ip:5,ron:25,nf:false,note:"$5 acknowledgment; $2 jurat/oath; $25 for RON."},
  NV:{name:"Nevada",ip:15,ron:25,nf:false,note:"$15 first sig, $7.50 each additional; $25 RON. Must display fees."},
  NH:{name:"New Hampshire",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON."},
  NJ:{name:"New Jersey",ip:2.5,ron:null,nf:false,note:"$2.50 standard; $15 in-state; $25 interstate. No set RON fee."},
  NM:{name:"New Mexico",ip:5,ron:30,nf:false,note:"$5 + $25 RON technology fee for RON."},
  NY:{name:"New York",ip:2,ron:25,nf:false,note:"$2 per person in-person; $25 for RON."},
  NC:{name:"North Carolina",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON. Must advise clients of fees."},
  ND:{name:"North Dakota",ip:5,ron:5,nf:false,note:"$5 max per act including RON."},
  OH:{name:"Ohio",ip:5,ron:25,nf:false,note:"$5 in-person; $25 for RON."},
  OK:{name:"Oklahoma",ip:5,ron:25,nf:false,note:"$5 in-person; $25 for RON."},
  OR:{name:"Oregon",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON."},
  PA:{name:"Pennsylvania",ip:5,ron:null,nf:false,note:"$5 per act, $2 each additional name. Must advise of fees."},
  RI:{name:"Rhode Island",ip:25,ron:25,nf:false,note:"$25 per act (both in-person and RON)."},
  SC:{name:"South Carolina",ip:5,ron:null,nf:false,note:"$5 max per act. RON not authorized."},
  SD:{name:"South Dakota",ip:10,ron:10,nf:false,note:"$10 per document."},
  TN:{name:"Tennessee",ip:null,ron:25,nf:true,note:"No set fee in-person; $25 for RON."},
  TX:{name:"Texas",ip:10,ron:25,nf:false,note:"$10 first sig, $1 each additional; $25 + regular fee for RON."},
  UT:{name:"Utah",ip:10,ron:25,nf:false,note:"$10 in-person; $25 for RON."},
  VT:{name:"Vermont",ip:null,ron:null,nf:true,note:"No set fee schedule."},
  VA:{name:"Virginia",ip:10,ron:25,nf:false,note:"$10 in-person per act; $25 for RON per act."},
  WA:{name:"Washington",ip:15,ron:25,nf:false,note:"$15 per sig (updated Jun 2024); $25 for RON."},
  WV:{name:"West Virginia",ip:10,ron:10,nf:false,note:"$10 max per act."},
  WI:{name:"Wisconsin",ip:5,ron:5,nf:false,note:"$5 in-person; $5 + technology fee for RON."},
  WY:{name:"Wyoming",ip:10,ron:10,nf:false,note:"$10 in-person; $10 + technology fee for RON."},
};

const STATE_TAX = {
  AL:{type:"progressive",rate:0.05,stdDed:3000,brackets:[[500,0.02],[3000,0.04],[Infinity,0.05]],note:"Top rate 5%. Local taxes may also apply."},
  AK:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
  AZ:{type:"flat",rate:0.025,stdDed:14600,brackets:[[Infinity,0.025]],note:"Flat 2.5% rate."},
  AR:{type:"progressive",rate:0.044,stdDed:2300,brackets:[[5100,0.02],[10300,0.04],[Infinity,0.044]],note:"Top rate 4.4% (2025)."},
  CA:{type:"progressive",rate:0.093,stdDed:5202,brackets:[[10756,0.01],[25499,0.02],[40245,0.04],[54996,0.06],[68350,0.08],[349137,0.093],[418961,0.103],[698274,0.113],[Infinity,0.123]],note:"Top rate 9.3% (+ 1% mental health surcharge above $1M). Highest in US."},
  CO:{type:"flat",rate:0.044,stdDed:14600,brackets:[[Infinity,0.044]],note:"Flat 4.4% rate."},
  CT:{type:"progressive",rate:0.0699,stdDed:15000,brackets:[[10000,0.02],[50000,0.045],[100000,0.055],[200000,0.06],[250000,0.065],[500000,0.069],[Infinity,0.0699]],note:"Top rate 6.99%."},
  DE:{type:"progressive",rate:0.066,stdDed:3250,brackets:[[2000,0],[5000,0.022],[10000,0.039],[20000,0.048],[25000,0.052],[60000,0.055],[Infinity,0.066]],note:"Top rate 6.6%."},
  DC:{type:"progressive",rate:0.0895,stdDed:14600,brackets:[[10000,0.04],[40000,0.06],[60000,0.065],[250000,0.085],[500000,0.0875],[1000000,0.089],[Infinity,0.0895]],note:"Top rate 8.95%."},
  FL:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
  GA:{type:"flat",rate:0.0519,stdDed:12000,brackets:[[Infinity,0.0519]],note:"Flat 5.19% rate (reduced from 5.39% in 2025)."},
  HI:{type:"progressive",rate:0.11,stdDed:4400,brackets:[[9600,0.014],[19200,0.032],[28800,0.055],[38400,0.064],[48000,0.068],[150000,0.072],[175000,0.076],[200000,0.079],[325000,0.083],[Infinity,0.11]],note:"Top rate 11%. Most complex brackets in US."},
  ID:{type:"flat",rate:0.053,stdDed:14600,brackets:[[Infinity,0.053]],note:"Flat 5.3% rate (reduced from 5.695% in 2025)."},
  IL:{type:"flat",rate:0.0495,stdDed:0,brackets:[[Infinity,0.0495]],note:"Flat 4.95% rate. No standard deduction."},
  IN:{type:"flat",rate:0.03,stdDed:1000,brackets:[[Infinity,0.03]],note:"Flat 3.0% rate (2025). County taxes may add 0.5–3%."},
  IA:{type:"flat",rate:0.038,stdDed:14600,brackets:[[Infinity,0.038]],note:"Flat 3.8% rate (moved from progressive in 2025)."},
  KS:{type:"progressive",rate:0.057,stdDed:3500,brackets:[[15000,0.031],[30000,0.0525],[Infinity,0.057]],note:"Top rate 5.7%."},
  KY:{type:"flat",rate:0.04,stdDed:3160,brackets:[[Infinity,0.04]],note:"Flat 4.0% rate."},
  LA:{type:"flat",rate:0.03,stdDed:12500,brackets:[[Infinity,0.03]],note:"Flat 3.0% rate (switched from progressive in 2025)."},
  ME:{type:"progressive",rate:0.0715,stdDed:14600,brackets:[[26050,0.058],[61600,0.0675],[Infinity,0.0715]],note:"Top rate 7.15%."},
  MD:{type:"progressive",rate:0.0625,stdDed:2400,brackets:[[1000,0.02],[2000,0.03],[3000,0.04],[100000,0.0475],[125000,0.05],[150000,0.0525],[250000,0.055],[Infinity,0.0625]],note:"Top rate 6.25%. County/city taxes add 2.25–3.2%."},
  MA:{type:"flat",rate:0.05,stdDed:0,brackets:[[Infinity,0.05]],note:"Flat 5% rate. 4% surtax on income above $1M."},
  MI:{type:"flat",rate:0.0425,stdDed:5600,brackets:[[Infinity,0.0425]],note:"Flat 4.25% rate. Local taxes may apply."},
  MN:{type:"progressive",rate:0.0985,stdDed:14575,brackets:[[31690,0.0535],[104090,0.068],[193240,0.0785],[Infinity,0.0985]],note:"Top rate 9.85%."},
  MS:{type:"flat",rate:0.047,stdDed:2300,brackets:[[10000,0],[Infinity,0.047]],note:"Flat 4.7% above $10k (reducing to 4% by 2026)."},
  MO:{type:"progressive",rate:0.048,stdDed:14600,brackets:[[1207,0],[2414,0.015],[3621,0.02],[4828,0.025],[6035,0.03],[7242,0.035],[8432,0.04],[9639,0.045],[Infinity,0.048]],note:"Top rate 4.8%. Capital gains exempt."},
  MT:{type:"progressive",rate:0.059,stdDed:14600,brackets:[[3600,0.01],[6300,0.02],[9900,0.03],[14400,0.04],[19800,0.05],[Infinity,0.059]],note:"Top rate 5.9%."},
  NE:{type:"progressive",rate:0.0464,stdDed:7900,brackets:[[3700,0.0246],[22170,0.0351],[35730,0.0501],[Infinity,0.0464]],note:"Top rate 4.64% (reduced from 5.2% in 2025)."},
  NV:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
  NH:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax (interest/dividends tax repealed 2025)."},
  NJ:{type:"progressive",rate:0.1075,stdDed:1000,brackets:[[20000,0.014],[35000,0.0175],[40000,0.035],[75000,0.055],[500000,0.0637],[1000000,0.0897],[Infinity,0.1075]],note:"Top rate 10.75%."},
  NM:{type:"progressive",rate:0.059,stdDed:14600,brackets:[[5500,0.015],[11000,0.032],[16000,0.047],[210000,0.049],[Infinity,0.059]],note:"Top rate 5.9% (2025, added new 4.3% bracket)."},
  NY:{type:"progressive",rate:0.109,stdDed:8000,brackets:[[17150,0.04],[23600,0.045],[27900,0.0525],[161550,0.0585],[323200,0.0625],[2155350,0.0685],[5000000,0.0965],[25000000,0.103],[Infinity,0.109]],note:"Top rate 10.9%. NYC adds up to 3.876%."},
  NC:{type:"flat",rate:0.0425,stdDed:12750,brackets:[[Infinity,0.0425]],note:"Flat 4.25% rate (reduced from 4.5% in 2025)."},
  ND:{type:"progressive",rate:0.029,stdDed:14600,brackets:[[44725,0],[Infinity,0.029]],note:"Top rate 2.9% (two brackets)."},
  OH:{type:"progressive",rate:0.03125,stdDed:0,brackets:[[26050,0],[Infinity,0.03125]],note:"Two rates: 0% up to $26,050; 2.75%–3.125% above. Moves to flat 2.75% in 2026."},
  OK:{type:"progressive",rate:0.045,stdDed:6350,brackets:[[1000,0.0025],[2500,0.0075],[3750,0.0175],[4900,0.0275],[7200,0.0375],[Infinity,0.045]],note:"Top rate 4.5% (2026 simplification in progress)."},
  OR:{type:"progressive",rate:0.099,stdDed:2420,brackets:[[18400,0.0475],[46200,0.075],[250000,0.09],[Infinity,0.099]],note:"Top rate 9.9%."},
  PA:{type:"flat",rate:0.0307,stdDed:0,brackets:[[Infinity,0.0307]],note:"Flat 3.07% rate. Local earned income taxes also apply (1–3%)."},
  RI:{type:"progressive",rate:0.0599,stdDed:10100,brackets:[[77450,0.0375],[176050,0.0475],[Infinity,0.0599]],note:"Top rate 5.99%."},
  SC:{type:"progressive",rate:0.063,stdDed:14600,brackets:[[3460,0],[17330,0.03],[Infinity,0.063]],note:"Top rate 6.3% (reverted from 6.2% for 2025)."},
  SD:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
  TN:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax (Hall Tax on dividends fully repealed)."},
  TX:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
  UT:{type:"flat",rate:0.045,stdDed:0,brackets:[[Infinity,0.045]],note:"Flat 4.5% rate (reduced from 4.55% in 2025)."},
  VT:{type:"progressive",rate:0.0875,stdDed:7000,brackets:[[45400,0.0335],[110050,0.066],[229550,0.076],[Infinity,0.0875]],note:"Top rate 8.75%."},
  VA:{type:"progressive",rate:0.0575,stdDed:8000,brackets:[[3000,0.02],[5000,0.03],[17000,0.05],[Infinity,0.0575]],note:"Top rate 5.75%. Filing deadline May 1."},
  WA:{type:"none",rate:0,stdDed:0,brackets:[],note:"No general income tax (capital gains tax only)."},
  WV:{type:"progressive",rate:0.0482,stdDed:0,brackets:[[10000,0.0236],[25000,0.0315],[40000,0.0354],[60000,0.0472],[Infinity,0.0482]],note:"Top rate 4.82% (all rates reduced in 2025)."},
  WI:{type:"progressive",rate:0.0765,stdDed:12760,brackets:[[14320,0.0354],[28640,0.0465],[315310,0.053],[Infinity,0.0765]],note:"Top rate 7.65%."},
  WY:{type:"none",rate:0,stdDed:0,brackets:[],note:"No state income tax."},
};

function calcStateTax(stateCode, federalTaxableIncome) {
  const st = STATE_TAX[stateCode];
  if (!st || st.type === "none") return 0;
  const income = Math.max(0, federalTaxableIncome - (st.stdDed || 0));
  if (st.type === "flat") return income * st.rate;
  // Progressive: walk brackets
  let tax = 0, prev = 0;
  for (const [cap, rate] of st.brackets) {
    if (income <= prev) break;
    const chunk = Math.min(income, cap) - prev;
    tax += chunk * rate;
    prev = cap;
    if (cap === Infinity) break;
  }
  return tax;
}

const LLC_GUIDE = {
  soleprop: {
    label: "Sole Proprietor / Single-Member LLC",
    icon: "👤",
    summary: "Most notaries start here. Income flows directly to Schedule C on your personal return. You pay SE tax on all net profit (after exemptions).",
    pros: ["Simplest setup — no separate business return", "No payroll taxes or W-2s to yourself", "Losses offset other personal income"],
    cons: ["SE tax (15.3%) on all net profit", "No ability to split income as salary vs. distributions"],
    seImpact: "full",
    cpaTalking: [
      "Do I qualify for the IRC §1402(c) stamp fee SE tax exclusion?",
      "Should I elect S-Corp status once my net profit exceeds ~$50,000?",
      "Can I deduct my health insurance premiums as a self-employed person?",
      "What home office method should I use — simplified or actual?",
    ]
  },
  scorp: {
    label: "S-Corp Election (LLC or Inc.)",
    icon: "🏢",
    summary: "Once net profit consistently exceeds ~$50k–$80k, electing S-Corp status can save significant SE tax. You pay yourself a 'reasonable salary' — only that salary is subject to SE tax. The rest passes through as a distribution (no SE tax).",
    pros: ["SE tax only on salary portion — not total profit", "Distributions are tax-free from SE tax", "Can save $5,000–$15,000+/yr at higher income levels"],
    cons: ["Must pay yourself 'reasonable compensation' (IRS scrutinizes this)", "Separate business tax return (Form 1120-S) — $500–$2,000/yr CPA cost", "Payroll setup required (QuickBooks Payroll, Gusto, etc.)", "More complex recordkeeping"],
    seImpact: "partial",
    cpaTalking: [
      "What's a 'reasonable salary' for a notary doing my volume?",
      "At what net profit level does S-Corp election make financial sense for me?",
      "What are the ongoing compliance costs vs. SE tax savings?",
      "How do I set up payroll for myself as a sole employee?",
      "Does the IRC §1402(c) stamp exclusion still apply to salary vs. distributions?",
    ]
  },
  multimember: {
    label: "Multi-Member LLC / Partnership",
    icon: "🤝",
    summary: "If you have a business partner (spouse, contractor), a multi-member LLC files Form 1065. Each partner's share flows to their personal return via Schedule K-1. SE tax applies to active partners' shares.",
    pros: ["Flexible profit/loss allocation between partners", "No corporate-level income tax"],
    cons: ["Form 1065 partnership return required annually", "Each active partner pays SE tax on their distributive share", "More complex — legal partnership agreement recommended"],
    seImpact: "full",
    cpaTalking: [
      "How should we split income to minimize overall SE tax?",
      "Should we consider an S-Corp election at the partnership level?",
      "What documentation do I need for a spouse as a partner vs. employee?",
    ]
  }
};

const STREAMS_DEF = [
  {id:"ron",   label:"RON Sessions",           icon:"🖥️", unit:"session", notarial:true},
  {id:"ip",    label:"In-Person Notarizations", icon:"📝", unit:"appt",    notarial:true},
  {id:"lsa",   label:"Loan Signing Agent",      icon:"📋", unit:"signing", notarial:true},
  {id:"apost", label:"Apostille / Doc Prep",    icon:"🌍", unit:"order",   notarial:false},
  {id:"mobile",label:"Mobile Travel Fees",      icon:"🚗", unit:"trip",    notarial:false},
  {id:"coach", label:"Coaching / Content",      icon:"🎓", unit:"session", notarial:false},
  {id:"other", label:"Other Income",            icon:"💼", unit:"item",    notarial:false},
];
function emptyMonths() { return Array(12).fill(null).map(()=>({cnt:0,gross:0})); }
function streamYr(s) { return (s.months||emptyMonths()).reduce((a,m)=>a+(m.gross||0),0); }
function streamSessions(s) { return (s.months||emptyMonths()).reduce((a,m)=>a+(m.cnt||0),0); }
function streamAvgPerSession(s) {
  const yr=streamYr(s); const sess=streamSessions(s);
  return sess>0?Math.round(yr/sess):0;
}

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const THIS_YEAR = new Date().getFullYear();
const fmt  = n => Math.abs(n||0).toLocaleString("en-US",{maximumFractionDigits:0});
const fmtD = n => Math.abs(n||0).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2});


const TAX_YEARS = {
  2023: {
    mileage: 0.655,
    brackets: [[11000,0.10],[44725,0.12],[95375,0.22],[182050,0.24],[231250,0.32],[578125,0.35]],
    threshold: [11000,44725,95375,182050,231250,578125],
    tax:       [0,1100,5147,16290,37104,52832],
    sepMax: 66000,
    stdDed: 13850,
  },
  2024: {
    mileage: 0.67,
    brackets: [[11600,0.10],[47150,0.12],[100525,0.22],[191950,0.24],[243725,0.32],[609350,0.35]],
    threshold: [11600,47150,100525,191950,243725,609350],
    tax:       [0,1160,5426,17168.50,39110.50,55462.50],
    sepMax: 69000,
    stdDed: 14600,
  },
  2025: {
    mileage: 0.70,
    brackets: [[11925,0.10],[48475,0.12],[103350,0.22],[197300,0.24],[250525,0.32],[626350,0.35]],
    threshold: [11925,48475,103350,197300,250525,626350],
    tax:       [0,1192.50,5578.50,17651,40199,57231],
    sepMax: 70000,
    stdDed: 14600,
  },
  2026: {
    mileage: 0.70,
    brackets: [[12000,0.10],[49000,0.12],[104000,0.22],[198000,0.24],[252000,0.32],[630000,0.35]],
    threshold: [12000,49000,104000,198000,252000,630000],
    tax:       [0,1200,5628,17762,40286,57374],
    sepMax: 71000,
    stdDed: 15000,
  },
  2027: {
    mileage: 0.71,
    brackets: [[12200,0.10],[49800,0.12],[105500,0.22],[200000,0.24],[254000,0.32],[635000,0.35]],
    threshold: [12200,49800,105500,200000,254000,635000],
    tax:       [0,1220,5736,18026,40730,57926],
    sepMax: 72000,
    stdDed: 15600,
  },
};

function fedTax(t, yr) {
  if (t<=0) return 0;
  const y = TAX_YEARS[yr] || TAX_YEARS[2025];
  const [b1,b2,b3,b4,b5] = y.threshold;
  const [,t1,t2,t3,t4,t5] = y.tax;
  const [,r1,r2,r3,r4,r5,r6] = y.brackets.map(b=>b[1]);
  if (t<=b1) return t*r1;
  if (t<=b2) return t1+(t-b1)*r2;
  if (t<=b3) return t2+(t-b2)*r3;
  if (t<=b4) return t3+(t-b3)*r4;
  if (t<=b5) return t4+(t-b4)*r5;
  return t5+(t-b5)*r6;
}
function bracketLabel(t, yr) {
  const y = TAX_YEARS[yr] || TAX_YEARS[2025];
  const [b1,b2,b3,b4,b5] = y.threshold;
  if (t<=b1) return "10%";
  if (t<=b2) return "12%";
  if (t<=b3) return "22%";
  if (t<=b4) return "24%";
  if (t<=b5) return "32%";
  return "35%+";
}
function mileageRate(yr) {
  return (TAX_YEARS[yr]||TAX_YEARS[2025]).mileage;
}
function sepMax(yr) {
  return (TAX_YEARS[yr]||TAX_YEARS[2025]).sepMax;
}


const LIGHT = {
  bg:"#f5f7f5", card:"#ffffff", navy:"#1a2e1a",
  green:"#2d6a2d", gl:"#4caf50", gp:"#e8f5e8",
  gold:"#c8922a", golp:"#fef9ec", goll:"#f0c060",
  slate:"#6b7f6b", border:"#ddeadd",
  red:"#c0392b", redp:"#fdf0f0",
  teal:"#1a7a6e", tealp:"#e8f5f3",
};
const DARK = {
  bg:"#0d1a0d", card:"#162616", navy:"#e8f5e8",
  green:"#5abf5a", gl:"#72c872", gp:"#1e3a1e",
  gold:"#f5c842", golp:"#2d2210", goll:"#f5c842",
  slate:"#9dbf9d", border:"#2e4a2e",
  red:"#f07070", redp:"#2d1414",
  teal:"#52c4ba", tealp:"#0e2820",
};
// Module-level C (always light) — used by sub-components outside main App
// The main component overrides C with darkMode awareness
let C = LIGHT;
// ── ACCESS TOKEN GATE ───────────────────────────────────────────────────────
// Hashed token list — plaintext tokens are never stored in code
const TOKEN_HASHES = new Set(["12a1e5d48b3cb59da40e", "9aa4968b3d7f9532b72f", "409524f45118e751e9d4", "2bd3313da4d1a6c58555", "5b5a4005ba512fb98c66", "e72cd3ccdbacc5432c49", "6ef4c68db94b93a52bc8", "fef906be3d528a52eb4b", "0da5193a6527713f5018", "b3e57af251abf09ae201", "8c78f2e8271a10322b53", "6248b17e294af550be9b", "d181e39595c159e4b334", "56e7375f906ef990003d", "7f8e47bd1e95d758b464", "d74d060ed758e35ecdbd", "29f8f216a0828710a2a6", "3bec09652d8c20ec4ee4", "dfbccb6ece4b8b445f48", "f515b9f824dd7cde636d", "d75de2eff3a9983064a8", "5f447fab52be75f790dc", "4a715a70bef88636db05", "39ca9c36dd948ba24491", "9ca93a59be2e726191d1", "0d1ff2ea7e3aed4d6c12", "0f60edffa16b63b6f8b1", "e3d65e4a994c1a1c5a74", "f0a4569966a63af7457d", "0bccbf94e54055213fe0", "c9ae887261f8a0d91c7c", "96a59af3258a62b25bc7", "4e8aa27fad323ac7a740", "1153917621a4b824d617", "55e3e11e557b3ce735a8", "c48d082ad4c239c1503a", "04ecc9a8dca426ca1a79", "fbbef0bdc0ae2c2ac719", "00b130d713d5ac5eb930", "fb5d1b40b5da871204f2", "c24257a8791af94187a4", "1b4075a96e1ee3f0da83", "e9ee579a5dfd527cd2e4", "b3ad7276776505211b69", "375fb65440e2d7ceadcc", "be8b744410cf7eab044b", "c8c02089ca1c386da2fe", "4eb767ae0c398a95ddf2", "dad52282a74e3089cbe2", "cdeb6b4b71107585b19b", "137c62683b1db0019718", "7edb8b6e7d3658154058", "3ffefaa696d1856f2c7f", "441a6157764b7eb197be", "f9dc90be0f53e6fdd1b4", "e5868579c5e91e6a54d0", "4bb3231ffe811e3e6200", "25ce4f89901800c47e28", "7cd596044a743560f073", "dddb8907927279d44b38", "0037f8e155c7391fbc7e", "bc791710df8257f2141c", "3aebeed05e75daff8a06", "184e9df36bcf01c44e2b", "2f026066f545907133a5", "7ca4749575aebb694d9f", "e59ffc6fc2a9599a7f8d", "93f832453762d57e7a2d", "6f5558afdcb8835ad670", "3cf71421060f3b05d4cc", "7cf19ff3f93aa540dec5", "05b3dba6bbc241db6649", "e8c5ddc445b4cf301477", "b1e48958d027c8a31931", "a34d71a08c286c5e799f", "cd2fefc2c6ef4ca26afa", "1581e703e47aa707f4ab", "3dd4b7d2b197a4fd177f", "f26a8d066204f6ebc687", "b0eefc0c4b063a29f1b6", "3f4627df0cdcf2a80fd8", "7111e6b417f07172f18f", "0e9775283e67220f8817", "eeba7f4f75635ce83da5", "5f902fa8076058d0a160", "add5f3b6c9ec49fc15dc", "7773d994e4950fcbd1fd", "e8314d54fcc67ddb8d85", "462dfb891f12eef3ecbe", "bb56562464feef254921", "c3dc9d5798a27107ddb4", "52848a596ee17e2110fb", "61e7f1ee667d9d352545", "553de2483d4828c9d0f3", "334ea28c4707f1eba44d", "7aab3a91661570dbdbc8", "5cb9776b80a019a7f980", "29a152e50514ee61c6e3", "09e90cef7310a272ed1e", "ebd3fb90e6d86e896515", "38b39286e527d63fcac6", "52acbbe0e9e8981d9d5e", "d5b00de618d6b1ad84c5", "fa1aa8c66da8f3ab0bdf", "3d99863e645b14a169cc", "3b2637af0fd5fed70dc9", "3ccec0f1ecfcf881e206", "a144bea871566b531aa6", "1035ec1b4aa22d8470fd", "7c218469f7cd7ac1a8b1", "69a1a2fbd3c771205b3a", "a261e79af4eff622835d", "0e8b8564cb6bbbf59845", "ad8aeede5a1a1f6c65b8", "aa3cad7cf663d693b505", "590d576a95a9b78e7c86", "878bb542de542fdd3219", "1aac8f462a125f1adbdc", "3ba54c769d4c57c52bb1", "35dd8adbb6b657a8be22", "0bbcf9c7e502c00e738f", "b7abbf2079839edd3773", "6f3c271d37bca8b0a87e", "983c8d998885808677c6", "bb3df65ef8dd8ba7f742", "8d200a88a492764fbe40", "3f07b4524f36a01d1876", "3b609c962e9a3610d9e4", "f6a80caa336084e560cd", "cc7d0a56bd9dd2995fa4", "ef33b813d7fa5045ddd0", "3f3a744c38b5a7b14b71", "e27972028216c4f9127d", "ab2e230e1570142a1de6", "859bfe6d3c4f100324e5", "db7985c7d5c35885e132", "4328079a6fe89744762e", "1c6eb7f1f4264593b5be", "fa101d94b2998b05713c", "797c3f40ed4bb413e18f", "774f7d44d0ffd5fb365b", "5cd43febb200b264a1fa", "62adc88ecfcef6cae11e", "82265a6af68c409755a2", "1dd8157d68ec93108497", "5429ae05b3e549b5d2ce", "57ac4e97edbb767602a7", "eb5591338f5e346be537", "34f1755aa41cfba9d14d", "9601d0992f5f674cc935", "12126318dc65f4ec9dbd", "6bfc556472b815c281d0", "a903248ba5a962542233", "56d2dc8b6bf4f996e237", "bbcb501f88f2e3aea7c8", "59df8e269fa96011ef40", "dbccafbdd7ce30563d77", "83c0b2c5bd37997a3728", "458e2be2f6003c651768", "9a5e0ad1e4f433c882ea", "82624abb8995056bda65", "cda12635d83604f639e8", "e29891ec841f6dc6dfa7", "b2710d1831b6cce3b47a", "563fe28f4aeb672e2b91", "1f8103b82aee0052fbc5", "6009bef074ca9dfcae47", "9fe0ae6c17bafb7f2ec3", "16016a4d521ead56dfe3", "27c0d7e524f2ba4f1c88", "9de44aeda6f2d74af4b6", "b79f857d2df0c5f418a5", "c36c4aed1d9c72507a48", "d704e4ac9bd0ccc28121", "575e541d086d520d7180", "0a6c80f223d154203c17", "6b49562d8a9ca653e946", "aab90941579089f3cbee", "1d6235648529ed8358ee", "38fff25b923a02e03702", "d7fe9a4cf81ccc28f98a", "0d6cebd721a8ae94c707", "41ea3587908880f3d876", "ebac1c12ad2fa5d30d6e", "709ad3dbdcbe49b0ca9b", "9b7250654a4fde2fe082", "6fbd0111da474d41a8be", "86599be1cc44df0730c2", "984f962f019195353cce", "62c301783409f70e0645", "c4a99123b55ed38b41b5", "419df7a93cdf755c466b", "ac7b3a3515883c539f95", "a8e701bb363af193edaa", "3270ec38bb9f97a8d9bb", "4507763a5f6e2b0f8d9b", "9c29b0fc685f7675aa50", "cffb0cb6ecf7323753b6", "ea10a9030175a0d250ec", "7a8aeb0e2101e06e0468"]);
async function hashToken(t) {
  const enc = new TextEncoder().encode(t.toUpperCase().trim());
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,"0")).join("").slice(0,20);
}
function getStoredToken() {
  try{return localStorage.getItem("ntt_access_token")||"";}catch(e){return "";}
}
function storeToken(t) {
  try{localStorage.setItem("ntt_access_token",t);}catch(e){}
}

// ── CLEAN SEED DATA (no competitor names, clearly placeholder) ────────────────
const SEED_INV = [];
const SEED_STREAMS = [];
const SEED_1099S = [];

const DEFAULT_STATE = {
  stateCode:"FL", useRON:false, customIP:"", customRON:"", taxYear:THIS_YEAR,
  streams:SEED_STREAMS, stamps:0,
  homePct:10, homeTotal:15000, mileage:0,
  software:0, equipment:0, education:0,
  marketing:0, insurance:0, supplies:0,
  invoices:SEED_INV, forms1099:SEED_1099S, entityType:"soleprop",
  recurringBills:[], // [{id,name,amt,cat,active}]
  mortgage:0, carPmt:0, utilities:0, groceries:0,
  childcare:0, subscriptions:0, personalOther:0, checkedItems:{},
  seenWelcome:false, seenHelp:{},
};

function storageKey(year) { return `ntt_v7_${year}`; }
function normalizeStreams(streams) {
  if (!Array.isArray(streams)) return [];
  return streams.map(s => {
    // Migrate old format months (plain numbers or old avg/cnt) to {cnt,gross}
    const rawMonths = s.months;
    if (!rawMonths || !Array.isArray(rawMonths)) {
      return {...s, months: emptyMonths(), stampsPerSession: s.stampsPerSession||1};
    }
    const normalized = rawMonths.map(m => {
      if (typeof m === 'number') {
        // Old format: number = session count; use avg if available
        return {cnt: m, gross: m * (s.avg||0)};
      }
      if (m && typeof m === 'object' && ('cnt' in m || 'gross' in m)) {
        return {cnt: m.cnt||0, gross: m.gross||0};
      }
      return {cnt:0, gross:0};
    });
    return {...s, months: normalized, stampsPerSession: s.stampsPerSession||1};
  });
}

function loadSaved(year) {
  const yr = year || THIS_YEAR;
  try {
    // One-time migration: lift ntt_v5 or ntt_v6 data into year-specific key
    const legacyV5 = localStorage.getItem("ntt_v5");
    if (legacyV5) {
      const parsed = JSON.parse(legacyV5);
      const legacyYear = parsed.taxYear || THIS_YEAR;
      localStorage.setItem(storageKey(legacyYear), legacyV5);
      localStorage.removeItem("ntt_v5");
      if (legacyYear === yr) return {...DEFAULT_STATE, ...parsed, taxYear:yr, streams:normalizeStreams(parsed.streams)};
    }
    const legacy = localStorage.getItem("ntt_v6");
    if (legacy) {
      const parsed = JSON.parse(legacy);
      const legacyYear = parsed.taxYear || THIS_YEAR;
      localStorage.setItem(storageKey(legacyYear), legacy);
      localStorage.removeItem("ntt_v6");
      if (legacyYear === yr) return {...DEFAULT_STATE, ...parsed, taxYear:yr, streams:normalizeStreams(parsed.streams)};
    }
    const raw = localStorage.getItem(storageKey(yr));
    if (raw) { const p=JSON.parse(raw); return {...DEFAULT_STATE,...p,taxYear:yr,streams:normalizeStreams(p.streams)}; }
  } catch(e) {}
  return {...DEFAULT_STATE, taxYear:yr};
}
function saveYear(yr, data) {
  try { localStorage.setItem(storageKey(yr), JSON.stringify(data)); } catch(e) {}
}
function clearYear(yr) {
  localStorage.removeItem(storageKey(yr));
}

// ── COMPONENTS ────────────────────────────────────────────────────────────────
function Card({children,style={},accent=false}) {
  return <div style={{background:C.card,borderRadius:16,padding:"20px 22px",border:`1.5px solid ${accent?C.green:C.border}`,boxShadow:accent?`0 0 0 3px ${C.gp}`:"none",...style}}>{children}</div>;
}
function Hd({children,sub}) {
  return <div style={{marginBottom:20}}>
    <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:24,color:C.navy,margin:0,lineHeight:1.2}}>{children}</h2>
    {sub&&<p style={{color:C.slate,fontSize:13,margin:"6px 0 0",lineHeight:1.6}}>{sub}</p>}
  </div>;
}
function Pill({label,value,sub,color=C.green}) {
  return <div style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"14px 16px",textAlign:"center"}}>
    <div style={{color,fontSize:20,fontWeight:800,fontFamily:"'DM Serif Display',serif"}}>{value}</div>
    <div style={{color:C.slate,fontSize:12,marginTop:3,fontWeight:600}}>{label}</div>
    {sub&&<div style={{color:color+"99",fontSize:11,marginTop:2}}>{sub}</div>}
  </div>;
}
function Slider({label,min,max,step=1,value,onChange,prefix="$",suffix="",note=""}) {
  const [manualOn,setManualOn] = useState(false);
  const [draft,setDraft]       = useState("");
  const clamped = Math.min(max,Math.max(min,value));
  const pct = Math.min(100,Math.max(0,((clamped-min)/(max-min))*100));
  const commit = () => { const n=Number(String(draft).replace(/[^0-9.]/g,"")); if(!isNaN(n)&&n>=0) onChange(n); setDraft(""); };
  return <div style={{marginBottom:22}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
      <div style={{flex:1,minWidth:0}}>
        <div style={{color:C.navy,fontSize:13,fontWeight:600}}>{label}</div>
        {note&&<div style={{color:C.slate,fontSize:12,marginTop:1}}>{note}</div>}
      </div>
      <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0,marginLeft:8}}>
        {!manualOn&&<span style={{color:C.green,fontSize:15,fontWeight:800}}>{prefix}{fmt(clamped)}{suffix}</span>}
        <button onClick={()=>{setManualOn(v=>!v);setDraft(String(value));}}
          style={{background:manualOn?C.green:C.gp,color:manualOn?"#fff":C.green,border:`1px solid ${C.green}50`,borderRadius:6,padding:"2px 7px",fontSize:10,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>
          {manualOn?"✕ close":"✏️ type"}
        </button>
      </div>
    </div>
    {manualOn?(
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <span style={{color:C.slate,fontSize:13,flexShrink:0}}>{prefix}</span>
        <input type="number" value={draft} onChange={e=>setDraft(e.target.value)}
          onBlur={commit} onKeyDown={e=>{if(e.key==="Enter"){commit();setManualOn(false);}}}
          placeholder={fmt(value)} autoFocus
          style={{flex:1,padding:"9px 12px",borderRadius:9,border:`2px solid ${C.green}`,fontSize:15,fontWeight:700,color:C.navy,fontFamily:"'DM Sans',sans-serif",background:C.gp}}/>
        <span style={{color:C.slate,fontSize:13,flexShrink:0}}>{suffix}</span>
        <button onClick={()=>{commit();setManualOn(false);}}
          style={{background:`linear-gradient(135deg,${C.green},${C.gl})`,color:"#fff",border:"none",borderRadius:8,padding:"9px 14px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>Set</button>
      </div>
    ):(
      <div style={{position:"relative",height:5,background:C.gp,borderRadius:3}}>
        <div style={{position:"absolute",left:0,top:0,height:"100%",width:`${pct}%`,background:`linear-gradient(90deg,${C.green},${C.gl})`,borderRadius:3}}/>
        <input type="range" min={min} max={max} step={step} value={clamped} onChange={e=>onChange(Number(e.target.value))}
          style={{position:"absolute",top:-8,left:0,width:"100%",opacity:0,cursor:"pointer",height:22}}/>
        <div style={{position:"absolute",top:-6.5,left:`calc(${pct}% - 9px)`,width:18,height:18,borderRadius:"50%",background:C.card,border:`2.5px solid ${C.green}`,boxShadow:`0 2px 8px ${C.green}33`,pointerEvents:"none"}}/>
      </div>
    )}
    {value>max&&!manualOn&&<div style={{color:C.gold,fontSize:11,marginTop:4}}>⚡ Value ${fmt(value)} exceeds slider max — use ✏️ type to adjust</div>}
  </div>;
}
function Alrt({type,title,msg,compact=false,onClick}) {
  const M={warn:{c:C.gold,bg:C.golp,i:"🔔"},danger:{c:C.red,bg:C.redp,i:"⚠️"},success:{c:C.teal,bg:C.tealp,i:"✅"},info:{c:C.green,bg:C.gp,i:"ℹ️"}};
  const {c,bg,i}=M[type]||M.info;
  return <div onClick={onClick} style={{background:bg,border:`1px solid ${c}40`,borderLeft:`4px solid ${c}`,borderRadius:8,padding:compact?"9px 14px":"12px 16px",marginBottom:10,display:"flex",gap:10,cursor:onClick?"pointer":"default"}}>
    <span style={{fontSize:14,marginTop:1,flexShrink:0}}>{i}</span>
    <div style={{flex:1}}>
      <div style={{color:c,fontWeight:700,fontSize:13}}>{title}{onClick&&<span style={{fontSize:11,marginLeft:8,opacity:.7}}>→ View</span>}</div>
      {msg&&<div style={{color:C.slate,fontSize:12,marginTop:3,lineHeight:1.5}}>{msg}</div>}
    </div>
  </div>;
}
function PLRow({label,value,bold,green,red,gray,indent=0,sep,tag}) {
  if (sep) return <div style={{borderTop:`1.5px solid ${C.border}`,margin:"8px 0"}}/>;
  const color=green?C.green:red?C.red:gray?C.slate:C.navy;
  return <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",paddingLeft:indent*14}}>
    <div style={{display:"flex",alignItems:"center",gap:7}}>
      <span style={{fontSize:bold?13:12,color:bold?C.navy:C.slate,fontWeight:bold?700:400}}>{label}</span>
      {tag&&<span style={{background:tag.bg,color:tag.c,fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:10}}>{tag.t}</span>}
    </div>
    <span style={{fontSize:bold?14:12,fontWeight:bold?700:500,color}}>
      {typeof value==="string"?value:(value<0?"(":"")+"$"+fmt(value)+(value<0?")":"")}
    </span>
  </div>;
}
function SaveBadge({saved}) {
  return <div style={{display:"flex",alignItems:"center",gap:4,color:saved?C.teal:C.slate,fontSize:11,fontWeight:600,transition:"color 0.5s"}}>
    <span>{saved?"✓":"○"}</span><span>{saved?"Saved":"Saving..."}</span>
  </div>;
}
function NavBtn({children,active,onClick}) {
  return <button onClick={onClick} style={{background:active?C.gp:"none",color:active?C.green:C.slate,border:"none",borderBottom:`2.5px solid ${active?C.green:"transparent"}`,padding:"13px 13px",fontSize:13,fontWeight:active?700:500,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap",transition:"all .15s",flexShrink:0}}>{children}</button>;
}
function HelpBox({id,text,seen,onDismiss}) {
  if (seen) return null;
  return <div style={{background:C.tealp,border:`1.5px solid ${C.teal}50`,borderLeft:`4px solid ${C.teal}`,borderRadius:10,padding:"12px 14px",marginBottom:14,display:"flex",gap:10,alignItems:"flex-start"}}>
    <span style={{fontSize:14,flexShrink:0,marginTop:1}}>💡</span>
    <div style={{flex:1,color:C.navy,fontSize:14,lineHeight:1.7,opacity:0.9}}>{text}</div>
    <button onClick={()=>onDismiss(id)} style={{background:"none",border:"none",color:C.teal,cursor:"pointer",fontSize:16,padding:"0 2px",flexShrink:0,fontWeight:700,opacity:0.8}}>✕</button>
  </div>;
}
function ResetModal({onConfirm,onCancel}) {
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div style={{background:C.card,borderRadius:20,padding:"32px 28px",maxWidth:380,width:"100%",textAlign:"center"}}>
      <div style={{fontSize:36,marginBottom:12}}>🗑️</div>
      <h3 style={{color:C.navy,fontSize:18,marginBottom:8}}>Reset All Data?</h3>
      <p style={{color:C.slate,fontSize:14,lineHeight:1.65,marginBottom:24}}>This will clear all your income, deductions, invoices, and settings. This cannot be undone.</p>
      <div style={{display:"flex",gap:12}}>
        <button onClick={onCancel} style={{flex:1,padding:"12px",borderRadius:10,border:`1.5px solid ${C.border}`,background:C.card,color:C.slate,fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Cancel</button>
        <button onClick={onConfirm} style={{flex:1,padding:"12px",borderRadius:10,border:"none",background:C.red,color:"#fff",fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Yes, Reset</button>
      </div>
    </div>
  </div>;
}
function TokenGate({onUnlock}) {
  const [input,   setInput]   = React.useState("");
  const [error,   setError]   = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const tryUnlock = async()=>{
    if(!input.trim()){setError("Please enter your access token.");return;}
    setLoading(true); setError("");
    try {
      const h = await hashToken(input.trim());
      if(TOKEN_HASHES.has(h)){
        storeToken(input.trim().toUpperCase());
        onUnlock();
      } else {
        setError("Invalid token. Check your order confirmation email from Stan Store.");
        setLoading(false);
      }
    } catch(e) {
      setError("Verification failed. Please try again.");
      setLoading(false);
    }
  };

  return(
    <div style={{minHeight:"100vh",background:"#0f1a0f",display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{background:"#1a2a1a",borderRadius:24,padding:"44px 32px",maxWidth:440,width:"100%",textAlign:"center",boxShadow:"0 24px 80px rgba(0,0,0,.5)",border:"1px solid #2a3f2a"}}>
        <div style={{fontSize:48,marginBottom:16}}>⚖️</div>
        <h1 style={{fontFamily:"'DM Serif Display',serif",fontSize:28,color:"#e8f5e8",marginBottom:8,lineHeight:1.2}}>Notary Tax Toolkit</h1>
        <p style={{color:"#4caf50",fontSize:13,fontWeight:700,letterSpacing:1.2,textTransform:"uppercase",marginBottom:6}}>by Notary Hero</p>
        <p style={{color:"#8aab8a",fontSize:14,lineHeight:1.7,marginBottom:28}}>Enter your access token from your purchase confirmation to unlock your toolkit.</p>
        <input
          autoFocus
          type="text"
          value={input}
          onChange={e=>setInput(e.target.value.toUpperCase())}
          onKeyDown={e=>e.key==="Enter"&&tryUnlock()}
          placeholder="NTT-XXXX-XXXX"
          style={{width:"100%",padding:"14px 16px",borderRadius:12,border:`2px solid ${error?"#e57373":input?"#4caf50":"#2a3f2a"}`,fontSize:16,fontFamily:"'DM Sans',sans-serif",color:"#e8f5e8",background:"#0f1a0f",textAlign:"center",marginBottom:12,boxSizing:"border-box",letterSpacing:2,outline:"none",transition:"border .2s"}}
        />
        {error&&<div style={{color:"#e57373",fontSize:13,marginBottom:12,lineHeight:1.5}}>{error}</div>}
        <button
          onClick={tryUnlock}
          disabled={loading}
          style={{width:"100%",padding:"14px",borderRadius:12,border:"none",background:loading?"#2a3f2a":"linear-gradient(135deg,#2d6a2d,#4caf50)",color:"#fff",fontWeight:700,fontSize:15,cursor:loading?"default":"pointer",fontFamily:"'DM Sans',sans-serif",transition:"all .2s"}}>
          {loading?"Verifying...":"Unlock Toolkit →"}
        </button>
        <div style={{marginTop:20,color:"#4a6a4a",fontSize:12,lineHeight:1.7}}>
          Don't have a token?{" "}
          <a href="https://notaryhero.com" style={{color:"#4caf50",textDecoration:"none",fontWeight:700}}>Purchase at notaryhero.com →</a>
        </div>
        <div style={{marginTop:12,color:"#3a5a3a",fontSize:11}}>Your token was emailed with your order confirmation.</div>
      </div>
    </div>
  );
}

function WelcomeModal({onDismiss, onSetName}) {
  const [step,setStep] = useState(0);
  const [nameInput,setNameInput] = useState("");
  const steps = [
    {icon:"👋",title:"Welcome to Notary Tax Toolkit",body:null,isName:true},
    {icon:"⚖️",title:"Set Your Stamp Exemption",body:"On the Home tab, select your fee type — In-Person, RON, or Both. This determines your §1402c SE tax exemption amount, which can save you hundreds in self-employment taxes. Don't skip this step."},
    {icon:"🏛️",title:"Pick Your State",body:"Select your state to get the correct stamp fee maximum and state income tax rate applied to your calculations automatically."},
    {icon:"💰",title:"Add Your Income",body:"Go to the Income tab and add every notary revenue stream. Enter sessions and gross earned per month for the most accurate tax picture."},
    {icon:"✂️",title:"Enter Your Deductions",body:"Use the Deductions tab for home office, mileage, software, education, and more. Then check Tax for your full quarterly payment breakdown."},
  ];
  const s = steps[step];
  const canAdvance = step===0?(nameInput.trim().length>0):true;
  const handleNext = ()=>{
    if(step===0){onSetName(nameInput.trim());}
    if(step<steps.length-1){setStep(s=>s+1);}else{onDismiss();}
  };
  return <div style={{position:"fixed",inset:0,background:"rgba(15,30,15,.82)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div style={{background:C.card,borderRadius:24,padding:"36px 28px",maxWidth:440,width:"100%",textAlign:"center",boxShadow:"0 24px 80px rgba(0,0,0,.4)"}}>
      <div style={{display:"flex",justifyContent:"center",gap:6,marginBottom:24}}>
        {steps.map((_,i)=><div key={i} style={{width:i===step?24:7,height:7,borderRadius:4,background:i===step?C.green:C.border,transition:"all .3s"}}/>)}
      </div>
      <div style={{fontSize:48,marginBottom:16}}>{s.icon}</div>
      <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:22,color:C.navy,marginBottom:10}}>{s.title}</h2>
      {s.isName?(
        <div>
          <p style={{color:C.slate,fontSize:14,lineHeight:1.7,marginBottom:20}}>Let's personalize your toolkit. What should we call you?</p>
          <input
            autoFocus
            type="text"
            value={nameInput}
            onChange={e=>setNameInput(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&canAdvance&&handleNext()}
            placeholder="Your first name"
            style={{width:"100%",padding:"13px 16px",borderRadius:12,border:`2px solid ${nameInput.trim()?C.green:C.border}`,fontSize:16,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.bg,textAlign:"center",marginBottom:20,boxSizing:"border-box",outline:"none"}}
          />
        </div>
      ):(
        <p style={{color:C.slate,fontSize:14,lineHeight:1.7,marginBottom:28}}>{s.body}</p>
      )}
      <div style={{display:"flex",gap:10}}>
        {step>0&&<button onClick={()=>setStep(s=>s-1)} style={{flex:1,padding:"12px",borderRadius:10,border:`1.5px solid ${C.border}`,background:C.card,color:C.slate,fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>← Back</button>}
        <button onClick={handleNext} disabled={!canAdvance} style={{flex:2,padding:"12px",borderRadius:10,border:"none",background:canAdvance?`linear-gradient(135deg,${C.green},${C.gl})`:"#ccc",color:"#fff",fontWeight:700,fontSize:14,cursor:canAdvance?"pointer":"default",fontFamily:"'DM Sans',sans-serif",transition:"background .2s"}}>
          {step===0?"Let's Go →":step<steps.length-1?"Next →":"Get Started →"}
        </button>
      </div>
      {step>0&&<button onClick={onDismiss} style={{background:"none",border:"none",color:C.slate,fontSize:12,cursor:"pointer",marginTop:14,fontFamily:"'DM Sans',sans-serif"}}>Skip tour</button>}
    </div>
  </div>;
}
function AddBillForm({onAdd, cats}) {
  const [name,setName] = useState("");
  const [amt, setAmt]  = useState("");
  const [cat, setCat]  = useState("Software");
  const submit = ()=>{
    if(!name||!amt) return;
    onAdd({name,amt:Number(amt),cat});
    setName(""); setAmt("");
  };
  return <div style={{display:"grid",gridTemplateColumns:"1fr auto auto auto",gap:8,alignItems:"center"}}>
    <input value={name} onChange={e=>setName(e.target.value)} placeholder="Bill name (e.g. Notary Platform)"
      style={{padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card,WebkitAppearance:"none",appearance:"none"}}/>
    <input type="number" value={amt} onChange={e=>setAmt(e.target.value)} placeholder="$/mo"
      style={{width:80,padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:12,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card}}/>
    <select value={cat} onChange={e=>setCat(e.target.value)} style={{padding:"8px 8px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card}}>
      {cats.map(c=><option key={c}>{c}</option>)}
    </select>
    <button onClick={submit} style={{background:C.green,color:"#fff",border:"none",borderRadius:8,padding:"8px 12px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>+ Add</button>
  </div>;
}

function ManualInvoiceForm({onAdd, cats, taxYear}) {
  const [vendor,  setVendor]  = useState("");
  const [amt,     setAmt]     = useState("");
  const [cat,     setCat]     = useState("Software");
  const [mo,      setMo]      = useState("");
  const [yr,      setYr]      = useState(String(taxYear));
  const [rec,     setRec]     = useState(false);
  const submit = ()=>{
    if(!vendor||!amt) return;
    onAdd({vendor,amt:Number(amt),cat,mo:mo?Number(mo):null,yr:Number(yr)||taxYear,rec});
    setVendor(""); setAmt(""); setMo("");
  };
  const inp = (v,s,ph,type="text")=>(
    <input type={type} value={v} onChange={e=>s(e.target.value)} placeholder={ph}
      style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,marginBottom:8,background:C.card,boxSizing:"border-box"}}/>
  );
  return <div>
    {inp(vendor,setVendor,"Vendor name (e.g. Ring Central)")}
    {inp(amt,setAmt,"Amount ($)","number")}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:8}}>
      <select value={cat} onChange={e=>setCat(e.target.value)} style={{padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card,WebkitAppearance:"none",appearance:"none"}}>
        {cats.map(c=><option key={c}>{c}</option>)}
      </select>
      <select value={mo} onChange={e=>setMo(e.target.value)} style={{padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card,WebkitAppearance:"none",appearance:"none"}}>
        <option value="">Month</option>
        {MONTHS.map((m,i)=><option key={m} value={i+1}>{m}</option>)}
      </select>
      <input type="number" value={yr} onChange={e=>setYr(e.target.value)} placeholder="Year"
        style={{padding:"8px 10px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,background:C.card,WebkitAppearance:"none",appearance:"none"}}/>
    </div>
    <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,cursor:"pointer",fontSize:13,color:C.slate}}>
      <input type="checkbox" checked={rec} onChange={e=>setRec(e.target.checked)} style={{width:16,height:16,accentColor:C.green}}/>
      Recurring monthly expense
    </label>
    <button onClick={submit} style={{width:"100%",background:`linear-gradient(135deg,${C.green},${C.gl})`,color:"#fff",border:"none",borderRadius:9,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
      + Add to Ledger
    </button>
  </div>;
}

function AddForm1099({onAdd}) {
  const [payer,setPayer]=useState(""); const [ein,setEin]=useState("");
  const [box1,setBox1]=useState(""); const [year,setYear]=useState(String(THIS_YEAR));
  const submit=()=>{ if(!payer||!box1) return; onAdd({payer,ein,box1:Number(box1),year:Number(year)}); setPayer("");setEin("");setBox1("");setYear(String(THIS_YEAR)); };
  const inp=(val,set,ph,type="text")=>(<input type={type} value={val} onChange={e=>set(e.target.value)} placeholder={ph} style={{width:"100%",padding:"9px 11px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy,marginBottom:8,background:C.card,boxSizing:"border-box"}}/>);
  return <div>{inp(payer,setPayer,"Payer name (e.g. Signing Service)")}{inp(ein,setEin,"EIN (optional)")}{inp(box1,setBox1,"Box 1 Amount ($)","number")}{inp(year,setYear,"Tax Year","number")}
    <button onClick={submit} style={{width:"100%",background:`linear-gradient(135deg,${C.green},${C.gl})`,color:"#fff",border:"none",borderRadius:10,padding:"13px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>+ Add 1099-NEC</button>
  </div>;
}

function RolloverPage({invoices,taxYear,onBack,onConfirm}) {
  const nextYr = taxYear+1;
  const [items, setItems] = useState(()=>invoices.map(inv=>({...inv,include:true,newAmt:inv.amt})));
  const included = items.filter(r=>r.include);
  const doConfirm = ()=>{
    const toAdd = included.map(r=>({...r,id:Date.now()+Math.random(),yr:nextYr,amt:r.newAmt,st:"confirmed",flag:null}));
    onConfirm(toAdd, nextYr);
  };
  return(
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:C.slate,cursor:"pointer",fontSize:20,padding:0}}>←</button>
        <div>
          <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:24,color:C.navy,margin:0}}>Copy Expenses to {nextYr}</h2>
          <p style={{color:C.slate,fontSize:13,margin:"4px 0 0"}}>Review your {taxYear} expenses — toggle off what won't continue, update any amounts that changed.</p>
        </div>
      </div>
      <div style={{background:C.golp,border:`1px solid ${C.gold}40`,borderRadius:12,padding:"12px 14px",marginBottom:14,display:"flex",gap:10,alignItems:"flex-start"}}>
        <span style={{fontSize:16,flexShrink:0}}>💡</span>
        <div style={{color:C.navy,fontSize:13,lineHeight:1.6}}>Checked items get copied to {nextYr} with the amounts you set. Unchecked items stay in {taxYear} only.</div>
      </div>
      {items.map((r,idx)=>(
        <div key={r.id} style={{background:C.card,borderRadius:12,padding:"12px 14px",marginBottom:9,border:`1.5px solid ${r.include?C.green+"60":C.border}`,opacity:r.include?1:0.45,transition:"all .15s"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <button onClick={()=>setItems(p=>p.map((x,i)=>i===idx?{...x,include:!x.include}:x))}
              style={{width:22,height:22,borderRadius:6,border:`2px solid ${r.include?C.green:C.border}`,background:r.include?C.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",padding:0,flexShrink:0,transition:"all .15s"}}>
              {r.include&&<span style={{color:"#fff",fontSize:11,fontWeight:900,lineHeight:1}}>✓</span>}
            </button>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:C.navy,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.vendor}</div>
              <div style={{color:C.slate,fontSize:11}}>{r.cat}{r.rec?" · 🔁":""}</div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
              <span style={{color:C.slate,fontSize:13}}>$</span>
              <input
                type="number" value={r.newAmt} min={0}
                onChange={e=>setItems(p=>p.map((x,i)=>i===idx?{...x,newAmt:Math.max(0,Number(e.target.value)||0)}:x))}
                style={{width:82,padding:"5px 7px",borderRadius:7,border:`1.5px solid ${r.newAmt!==r.amt?C.gold:C.border}`,fontSize:13,fontWeight:700,color:r.newAmt!==r.amt?C.gold:C.green,background:C.bg,textAlign:"right",fontFamily:"'DM Sans',sans-serif",outline:"none"}}
              />
              {r.newAmt!==r.amt&&<span style={{color:C.gold,fontSize:10,fontWeight:700}}>✏️</span>}
            </div>
          </div>
        </div>
      ))}
      <div style={{position:"sticky",bottom:0,background:C.bg,paddingTop:12,paddingBottom:6,marginTop:8,borderTop:`1px solid ${C.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <span style={{color:C.slate,fontSize:12}}>{included.length} of {items.length} selected</span>
          <button onClick={()=>setItems(p=>p.map(x=>({...x,include:true})))} style={{background:"none",border:"none",color:C.green,fontSize:12,fontWeight:700,cursor:"pointer",padding:0}}>Select all</button>
        </div>
        <button
          onClick={doConfirm}
          disabled={included.length===0}
          style={{width:"100%",background:included.length===0?"transparent":`linear-gradient(135deg,${C.green},${C.gl})`,color:included.length===0?C.slate:"#fff",border:included.length===0?`1px solid ${C.border}`:"none",borderRadius:11,padding:"14px",fontWeight:700,fontSize:14,cursor:included.length===0?"default":"pointer",fontFamily:"'DM Sans',sans-serif",transition:"all .2s"}}>
          {included.length===0?"Select at least one expense":`Copy ${included.length} expense${included.length===1?"":"s"} to ${nextYr} →`}
        </button>
      </div>
    </div>
  );
}

export default function NotaryTaxToolkitApp() {
  const [unlocked, setUnlocked] = React.useState(()=>{
    // Check if already unlocked (valid token in localStorage)
    const stored = getStoredToken();
    if(!stored) return false;
    // Token present — optimistically unlock, re-verify async in background
    return true;
  });

  // Background re-verify on mount (catches tampered localStorage)
  React.useEffect(()=>{
    const stored = getStoredToken();
    if(!stored){setUnlocked(false);return;}
    hashToken(stored).then(h=>{
      if(!TOKEN_HASHES.has(h)){
        localStorage.removeItem("ntt_access_token");
        setUnlocked(false);
      }
    });
  },[]);

  if(!unlocked) return <TokenGate onUnlock={()=>setUnlocked(true)}/>;
  return <NotaryTaxToolkit/>;
}

function NotaryTaxToolkit() {
  const init = loadSaved(THIS_YEAR);
  const [page,          setPage]          = useState("home");
  const [taxYear,       setTaxYear]       = useState(init.taxYear||THIS_YEAR);
  const [sc,            setSc]            = useState(init.stateCode||"FL");
  const [useRON,        setUseRON]        = useState(init.useRON||false);
  const [custIP,        setCustIP]        = useState(init.customIP||"");
  const [custRON,       setCustRON]       = useState(init.customRON||"");
  const [streams,       setStreams]       = useState(init.streams||SEED_STREAMS);
  const [stamps,        setStamps]        = useState(init.stamps||0);
  const [homePct,       setHomePct]       = useState(init.homePct||10);
  const [homeTotal,     setHomeTotal]     = useState(init.homeTotal||15000);
  const [mileage,       setMileage]       = useState(init.mileage||0);
  const [software,      setSoftware]      = useState(init.software||0);
  const [equipment,     setEquipment]     = useState(init.equipment||0);
  const [education,     setEducation]     = useState(init.education||0);
  const [marketing,     setMarketing]     = useState(init.marketing||0);
  const [insurance,     setInsurance]     = useState(init.insurance||0);
  const [supplies,      setSupplies]      = useState(init.supplies||0);
  const [invoices,      setInvoices]      = useState(init.invoices||SEED_INV);
  const [forms1099,     setForms1099]     = useState(init.forms1099||SEED_1099S);
  const [entityType,    setEntityType]    = useState(init.entityType||"soleprop");
  const [mortgage,      setMortgage]      = useState(init.mortgage||1800);
  const [carPmt,        setCarPmt]        = useState(init.carPmt||0);
  const [utilities,     setUtilities]     = useState(init.utilities||300);
  const [groceries,     setGroceries]     = useState(init.groceries||600);
  const [childcare,     setChildcare]     = useState(init.childcare||0);
  const [subscriptions, setSubscriptions] = useState(init.subscriptions||0);
  const [personalOther, setPersonalOther] = useState(init.personalOther||0);
  const [checkedItems,  setCheckedItems]  = useState({...(init.checkedItems||{}),...JSON.parse(localStorage.getItem('ntt_global_checks')||'{}')});
  const [seenWelcome,   setSeenWelcome]   = useState(init.seenWelcome||false);
  const [seenHelp,      setSeenHelp]      = useState(init.seenHelp||{});
  const [showReset,     setShowReset]     = useState(false);
  const [showMenu,      setShowMenu]      = useState(false);
  const [aiLoading,     setAiLoading]     = useState(false);
  const [aiResult,      setAiResult]      = useState(null);
  const [savedOK,       setSavedOK]       = useState(true);
  const [recurringBills, setRecurringBills] = useState(init.recurringBills||[]);
  const [copyDone,           setCopyDone]           = useState(false);
  const [importMsg,          setImportMsg]          = useState("");
  const [restoreCodeCopied,  setRestoreCodeCopied]  = useState(false);
  const [restoreInput,       setRestoreInput]        = useState("");
  const [showDataPanel,      setShowDataPanel]       = useState(false);
  const [payMode,            setPayMode]             = useState("annual");
  const [userName,           setUserName]           = useState(init.userName||"");
  const [darkMode,           setDarkMode]           = useState(()=>{
    try{return localStorage.getItem("ntt_darkmode")==="1";}catch(e){return false;}
  });
  C = darkMode ? DARK : LIGHT; // reassign module-level C for dark mode
  const fileRef = useRef();

  const si = SD[sc]||SD.FL;
  const stTax = STATE_TAX[sc]||STATE_TAX.FL;

  const effFee = useMemo(()=>{
    const ipFee  = si.ip!=null?si.ip:(Number(custIP)||10);
    const ronFee = si.ron!=null?si.ron:(Number(custRON)||25);
    if (useRON==="both") return Math.max(ipFee,ronFee);
    if (useRON===true)   return ronFee;
    return ipFee;
  },[si,useRON,custIP,custRON]);

  // ── Persist ─────────────────────────────────────────────────────────────────
  useEffect(()=>{
    setSavedOK(false);
    const t=setTimeout(()=>{
      try {
        saveYear(taxYear,{
          stateCode:sc,useRON,customIP:custIP,customRON:custRON,taxYear,
          streams,stamps,homePct,homeTotal,mileage,software,equipment,
          education,marketing,insurance,supplies,invoices,forms1099,entityType,
          recurringBills,userName,
          mortgage,carPmt,utilities,groceries,childcare,subscriptions,personalOther,
          checkedItems,seenWelcome,seenHelp,
        });
        setSavedOK(true);
      } catch(e){setSavedOK(true);}
    },700);
    return ()=>clearTimeout(t);
  },[sc,useRON,custIP,custRON,taxYear,streams,stamps,homePct,homeTotal,mileage,software,equipment,education,marketing,insurance,supplies,invoices,forms1099,entityType,recurringBills,userName,mortgage,carPmt,utilities,groceries,childcare,subscriptions,personalOther,checkedItems,seenWelcome,seenHelp]);

  // ── 1099 totals ─────────────────────────────────────────────────────────────
  const total1099     = useMemo(()=>forms1099.filter(f=>f.confirmed).reduce((s,f)=>s+(f.box1||0),0),[forms1099]);
  const income1099Gap = useMemo(()=>streams.reduce((s,st)=>s+streamYr(st),0)-total1099,[total1099,streams]);

  // ── Tax calc ─────────────────────────────────────────────────────────────────
  const T = useMemo(()=>{
    const monthlyIncome = Array(12).fill(0).map((_,mi)=>
      streams.reduce((s,st)=>{
        const mos = st.months||emptyMonths();
        return s+(mos[mi]?.gross||0);
      },0)
    );
    const grossYr  = monthlyIncome.reduce((s,v)=>s+v,0);
    const grossMo  = grossYr/12;
    const totalActs = streams
      .filter(st=>(STREAMS_DEF.find(d=>d.id===st.id)||{}).notarial)
      .reduce((s,st)=>s+streamSessions(st)*(Number(st.stampsPerSession)||1),0);
    const stampEx  = Math.min(totalActs*effFee,grossYr);
    const homeD    = (homePct/100)*homeTotal;
    const mileD    = mileage*mileageRate(taxYear);
    const totalD   = homeD+mileD+software+equipment+education+marketing+insurance+supplies;
    // SE tax: stamp exemption reduces SE base (IRC §1402(c)) — does NOT reduce federal income tax
    const seBase   = Math.max(0,grossYr-stampEx-totalD);
    const se       = seBase*0.153;
    const seD      = se*0.5;
    // Federal income tax: full profit minus deductions minus 1/2 SE deduction (no stamp exemption here)
    const fedBase  = Math.max(0,grossYr-totalD-seD);
    const taxable  = fedBase; // for bracket display purposes
    const fed      = fedTax(fedBase,taxYear);
    const stateTax = calcStateTax(sc,fedBase);
    const total    = fed+se+stateTax;
    const qtr      = total/4;
    const setPct   = grossYr>0?(total/grossYr)*100:0;
    const home     = grossYr-totalD-total;
    const eff      = grossYr>0?(total/grossYr)*100:0;
    // noExSave = how much the stamp exemption saves on SE tax alone
    const seNoExempt = Math.max(0,grossYr-totalD)*0.153;
    const noExSave = Math.max(0,seNoExempt-se);
    return {grossMo,grossYr,stampEx,seBase,homeD,mileD,totalD,fedBase,se,seD,taxable,fed,stateTax,total,qtr,setPct,home,eff,noExSave,bkt:bracketLabel(fedBase,taxYear),mileRate:mileageRate(taxYear),sepCap:sepMax(taxYear),totalActs,monthlyIncome};
  },[streams,effFee,homePct,homeTotal,mileage,software,equipment,education,marketing,insurance,supplies,sc,taxYear]);

  // ── Invoice trends ───────────────────────────────────────────────────────────
  const {missing,recurring,moExp} = useMemo(()=>{
    const vm={};
    invoices.filter(i=>i.rec&&i.mo).forEach(i=>{
      if(!vm[i.vendor])vm[i.vendor]={mos:[],amts:[],cat:i.cat};
      vm[i.vendor].mos.push(i.mo); vm[i.vendor].amts.push(i.amt);
    });
    const recurring=Object.entries(vm).filter(([,v])=>v.mos.length>=2).map(([name,v])=>({
      name,cat:v.cat,avg:v.amts.reduce((a,b)=>a+b,0)/v.amts.length,mos:v.mos,last:Math.max(...v.mos),
    }));
    const missing=[];
    recurring.forEach(v=>{
      const gap=Array.from({length:v.last},(_,i)=>i+1).filter(m=>!v.mos.includes(m));
      if(gap.length>0)missing.push({vendor:v.name,cat:v.cat,moNames:gap.map(m=>MONTHS[m-1]),avg:v.avg,total:gap.length*v.avg});
    });
    const moExp=MONTHS.map((_,i)=>{
      const m=i+1;
      const tot=invoices.filter(v=>v.mo===m&&v.st!=="flagged").reduce((s,v)=>s+v.amt,0);
      return {mo:MONTHS[i],tot,hasMissing:missing.some(a=>a.moNames.includes(MONTHS[i]))};
    });
    return {missing,recurring,moExp};
  },[invoices]);

  // ── Alerts ───────────────────────────────────────────────────────────────────
  const alerts = useMemo(()=>{
    const a=[];
    if(T.noExSave>0) a.push({type:"success",title:`Stamp Exemption Saves ~$${fmt(T.noExSave)}/yr`,msg:"Under IRC §1402(c), notarial stamp fees may be excluded from SE tax. Keep per-act records and confirm with your CPA.",tab:"home"});
    if(Math.abs(income1099Gap)>500){
      if(income1099Gap<0) a.push({type:"danger",title:`1099s Exceed Reported Income by $${fmt(Math.abs(income1099Gap))}`,msg:`Your 1099 total ($${fmt(total1099)}) is higher than reported income. The IRS receives these automatically.`,tab:"forms1099"});
      else a.push({type:"warn",title:`Income Gap: $${fmt(income1099Gap)} Not on 1099s`,msg:`You reported $${fmt(T.grossYr)} but only $${fmt(total1099)} is on 1099s. All income is taxable regardless of 1099s.`,tab:"forms1099"});
    }
    missing.forEach(m=>a.push({type:"warn",title:`Missing Invoices: ${m.vendor}`,msg:`No record for ${m.moNames.join(", ")}. Potential lost deduction: $${fmt(m.total)}.`,tab:"invoices"}));
    if(invoices.some(i=>i.st==="flagged")) a.push({type:"danger",title:"Flagged Invoice Needs Review",msg:"One or more invoices are flagged.",tab:"invoices"});
    if(equipment>0) a.push({type:"info",title:"Section 179 Available",msg:`$${fmt(equipment)} in equipment may qualify for full immediate deduction.`,tab:"deductions"});
    if(mileage<200&&streams.length>0) a.push({type:"info",title:"Low Mileage Logged",msg:"Consider MileIQ or Everlance for auto GPS tracking.",tab:"deductions"});
    return a;
  },[T,income1099Gap,total1099,missing,invoices,equipment,mileage,streams]);

  // ── Helpers ──────────────────────────────────────────────────────────────────
  const addStream    = id=>{if(streams.find(s=>s.id===id))return;setStreams(p=>[...p,{id,months:emptyMonths(),stampsPerSession:1}]);};
  const removeStream = id=>setStreams(p=>p.filter(s=>s.id!==id));
  const updStream    = (id,f,v)=>setStreams(p=>p.map(s=>s.id===id?{...s,[f]:v}:s));
  const updMonth     = (id,mi,field,v)=>setStreams(p=>p.map(s=>{
    if(s.id!==id) return s;
    const months=[...(s.months||emptyMonths())].map((m,j)=>j===mi?{...m,[field]:Math.max(0,Number(v)||0)}:m);
    return {...s,months};
  }));
  // Evergreen items persist globally; year-specific items are per-year
  const EVERGREEN_ITEMS = new Set(['boi1','boi2','w9','eo','commission','bond','records']);
  const getGlobalChecks = ()=>{ try{return JSON.parse(localStorage.getItem('ntt_global_checks')||'{}')}catch(e){return{}} };
  const setGlobalCheck  = (id, val)=>{ const c=getGlobalChecks(); c[id]=val; localStorage.setItem('ntt_global_checks',JSON.stringify(c)); };

  const toggleCheck = id=>{
    if(EVERGREEN_ITEMS.has(id)){
      const current = getGlobalChecks();
      const newVal = !current[id];
      setGlobalCheck(id, newVal);
      setCheckedItems(p=>({...p,[id]:newVal}));
    } else {
      setCheckedItems(p=>({...p,[id]:!p[id]}));
    }
  };

  // Load global checks into checkedItems on mount and year switch
  // Persist dark mode preference
  useEffect(()=>{
    try{localStorage.setItem("ntt_darkmode",darkMode?"1":"0");}catch(e){}
  },[darkMode]);

  const dismissHelp  = id=>setSeenHelp(p=>({...p,[id]:true}));
  const navigateTo   = tab=>{setPage(tab);setShowMenu(false);};

  const handleReset = ()=>{
    [2023,2024,2025,2026,2027].forEach(yr=>clearYear(yr));
    window.location.reload();
  };

  const copySummary = ()=>{
    const txt = `NOTARY TAX TOOLKIT — ${taxYear} SUMMARY\n\nState: ${si.name}\nAnnual Gross: $${fmt(T.grossYr)}\nStamp Exemption: $${fmt(T.stampEx)} (SE tax only — IRC §1402c)\nTotal Deductions: $${fmt(T.totalD)}\nFederal Taxable Income: $${fmt(T.fedBase)}\nFederal Tax: $${fmt(T.fed)} (${T.bkt})\nSE Tax: $${fmt(T.se)}\nState Tax: $${fmt(T.stateTax)}\nTotal Tax: $${fmt(T.total)} (${T.eff.toFixed(1)}% eff.)\nQuarterly Payment: $${fmt(T.qtr)}\nEst. Take-Home: $${fmt(T.home)}\nIRS Mileage Rate: $${T.mileRate}/mi\n\nGenerated by Notary Tax Toolkit — toolkit.notaryhero.com`;
    navigator.clipboard.writeText(txt).then(()=>{setCopyDone(true);setTimeout(()=>setCopyDone(false),2500);});
  };

  // ── DATA PORTABILITY ──────────────────────────────────────────────────────



  const generateRestoreCode = ()=>{
    const snapshot = {
      v:6,sc,useRON,cIP:custIP,cRON:custRON,yr:taxYear,
      st:streams,stamps,hPct:homePct,hTot:homeTotal,mi:mileage,
      sw:software,eq:equipment,ed:education,mkt:marketing,
      ins:insurance,sup:supplies,f1:forms1099,et:entityType,
      mor:mortgage,car:carPmt,ut:utilities,gr:groceries,
      cc:childcare,sub:subscriptions,po:personalOther,ci:checkedItems,
    };
    const code = btoa(JSON.stringify(snapshot)).replace(/=/g,'').match(/.{1,4}/g).join('-');
    navigator.clipboard.writeText(code).then(()=>{
      setRestoreCodeCopied(true);
      setTimeout(()=>setRestoreCodeCopied(false),3000);
    });
  };

  const applyRestoreCode = (code)=>{
    try {
      const clean = code.replace(/-/g,'');
      const padded = clean + '==='.slice((clean.length%4)||4);
      const data = JSON.parse(atob(padded));
      if(!data.v) throw new Error("Invalid code");
      if(data.sc)   setSc(data.sc);
      if(data.yr)   setTaxYear(data.yr);
      if(data.st)   setStreams(normalizeStreams(data.st));
      if(data.stamps!=null) setStamps(data.stamps);
      if(data.hPct!=null)   setHomePct(data.hPct);
      if(data.hTot)         setHomeTotal(data.hTot);
      if(data.mi!=null)     setMileage(data.mi);
      if(data.sw!=null)     setSoftware(data.sw);
      if(data.eq!=null)     setEquipment(data.eq);
      if(data.ed!=null)     setEducation(data.ed);
      if(data.mkt!=null)    setMarketing(data.mkt);
      if(data.ins!=null)    setInsurance(data.ins);
      if(data.sup!=null)    setSupplies(data.sup);
      if(data.f1)           setForms1099(data.f1);
      if(data.et)           setEntityType(data.et);
      if(data.mor!=null)    setMortgage(data.mor);
      if(data.car!=null)    setCarPmt(data.car);
      if(data.ut!=null)     setUtilities(data.ut);
      if(data.gr!=null)     setGroceries(data.gr);
      if(data.cc!=null)     setChildcare(data.cc);
      if(data.sub!=null)    setSubscriptions(data.sub);
      if(data.po!=null)     setPersonalOther(data.po);
      if(data.ci)           setCheckedItems(data.ci);
      if(data.useRON!=null) setUseRON(data.useRON);
      setRestoreInput("");
      setImportMsg("✓ Restore code applied!");
      setTimeout(()=>setImportMsg(""),3000);
    } catch(e) {
      setImportMsg("✗ Invalid restore code. Please check and try again.");
      setTimeout(()=>setImportMsg(""),4000);
    }
  };

  const emailSummary = ()=>{
    const subject = encodeURIComponent(`My Notary Tax Toolkit Summary — ${taxYear}`);
    const body = encodeURIComponent(
`NOTARY TAX TOOLKIT — ${taxYear} TAX SUMMARY
Generated: ${new Date().toLocaleDateString()}
toolkit.notaryhero.com

STATE: ${si.name}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
INCOME
  Annual Gross Revenue:        $${fmt(T.grossYr)}
  Monthly Gross:               $${fmt(T.grossMo)}

TAX CALCULATIONS
  Stamp Exemption (SE only):   $${fmt(T.stampEx)}
  Total Deductions:            $${fmt(T.totalD)}
  Federal Taxable Income:      $${fmt(T.fedBase)}
  Federal Tax (${T.bkt} bracket):  $${fmt(T.fed)}
  Self-Employment Tax:         $${fmt(T.se)}
  State Income Tax (${si.name}): $${fmt(T.stateTax)}
  ─────────────────────────────
  TOTAL TAX BURDEN:            $${fmt(T.total)}
  Effective Rate:              ${T.eff.toFixed(1)}%
  Quarterly Payment Est.:      $${fmt(T.qtr)}
  Estimated Take-Home:         $${fmt(T.home)}

IRS Mileage Rate (${taxYear}): $${T.mileRate}/mi

For estimation only. Consult a licensed CPA before filing.
© 2026 Notary Hero, LLC — toolkit.notaryhero.com`
    );
    window.location.href = "mailto:?subject="+subject+"&body="+body;
  };

  // ── Invoice AI ───────────────────────────────────────────────────────────────
  const handleFile = useCallback(async file=>{
    if(!file)return;
    setAiLoading(true);setAiResult(null);

    // File size check — Anthropic API limit is ~5MB for images
    if(file.size > 4.5 * 1024 * 1024){
      setAiResult({error:"File is too large. Please use an image under 4.5MB or compress your PDF."});
      setAiLoading(false);return;
    }

    try {
      // Detect media type — handle HEIC/HEIF from iPhone by converting to JPEG
      let processedFile = file;
      let mt = file.type;

      // HEIC/HEIF from iPhone camera — convert to JPEG via canvas
      if(!mt || mt==="image/heic" || mt==="image/heif" || file.name.match(/\.heic$/i)) {
        try {
          const img = await new Promise((res,rej)=>{
            const url=URL.createObjectURL(file);
            const i=new Image();
            i.onload=()=>{URL.revokeObjectURL(url);res(i);};
            i.onerror=()=>{URL.revokeObjectURL(url);rej(new Error("Cannot load image"));};
            i.src=url;
          });
          const canvas=document.createElement("canvas");
          canvas.width=img.naturalWidth; canvas.height=img.naturalHeight;
          canvas.getContext("2d").drawImage(img,0,0);
          const blob=await new Promise(r=>canvas.toBlob(r,"image/jpeg",0.85));
          processedFile=new File([blob],"receipt.jpg",{type:"image/jpeg"});
          mt="image/jpeg";
        } catch(e){ /* fall through to original */ mt="image/jpeg"; }
      }

      // Normalize media type
      if(!mt || mt==="application/octet-stream") {
        const ext=(file.name||"").split(".").pop().toLowerCase();
        mt = ext==="pdf"?"application/pdf":
             ext==="png"?"image/png":
             ext==="jpg"||ext==="jpeg"?"image/jpeg":
             ext==="webp"?"image/webp":
             ext==="gif"?"image/gif":"image/jpeg";
      }

      const b64=await new Promise((res,rej)=>{
        const r=new FileReader();
        r.onload=()=>res(r.result.split(",")[1]);
        r.onerror=rej;
        r.readAsDataURL(processedFile);
      });

      const known=[...new Set(invoices.filter(i=>i.rec).map(i=>i.vendor))].join(", ");
      const prompt=`You are a CPA assistant for a notary business. Known recurring vendors: ${known||"none"}. Analyze this receipt/invoice and return ONLY valid JSON (no markdown, no explanation): {"vendor":"string","amt":number,"cat":"Software|Equipment|Marketing|Phone-Comm|Insurance|Education|Office|Travel|Other","mo":1-12_or_null,"yr":number_or_null,"rec":boolean,"flag":"warning string or null"}`;

      const isImage = mt.startsWith("image/");
      const content=[
        isImage
          ? {type:"image",source:{type:"base64",media_type:mt,data:b64}}
          : {type:"document",source:{type:"base64",media_type:"application/pdf",data:b64}},
        {type:"text",text:prompt}
      ];

      // CRA inlines process.env.REACT_APP_* at build time — access directly
      const apiKey = process.env.REACT_APP_ANTHROPIC_KEY || "";
      if(!apiKey){
        setAiResult({error:"AI parsing not configured. Use the manual entry form below instead, or contact support at hello@notaryhero.com."});
        setAiLoading(false);return;
      }

      const resp=await fetch("https://api.anthropic.com/v1/messages",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "x-api-key":apiKey,
          "anthropic-version":"2023-06-01",
          "anthropic-dangerous-direct-browser-access":"true"
        },
        body:JSON.stringify({
          model:"claude-haiku-4-5-20251001",
          max_tokens:400,
          messages:[{role:"user",content}]
        })
      });

      if(!resp.ok){
        const errBody=await resp.text();
        let errMsg="Upload failed.";
        try {
          const errJson=JSON.parse(errBody);
          if(errJson.error?.type==="invalid_request_error") errMsg="File format not supported. Try a JPG, PNG, or PDF.";
          else if(errJson.error?.type==="authentication_error") errMsg="API key issue — contact hello@notaryhero.com.";
          else if(resp.status===429) errMsg="Too many requests. Wait a moment and try again.";
          else if(resp.status>=500) errMsg="Server error. Try again in a moment.";
          else errMsg=errJson.error?.message||errMsg;
        } catch(e){}
        throw new Error(errMsg);
      }

      const data=await resp.json();
      const txt=(data.content||[]).map(b=>b.text||"").join("").replace(/```json|```/g,"").trim();

      // Parse JSON safely
      let parsed;
      try { parsed=JSON.parse(txt); }
      catch(e) {
        // Try to extract JSON from response if it has extra text
        const match=txt.match(/\{[\s\S]*\}/);
        if(match) parsed=JSON.parse(match[0]);
        else throw new Error("AI returned an unexpected response. Try a clearer photo.");
      }

      if(!parsed.vendor&&!parsed.amt) throw new Error("Couldn't read this receipt. Try a clearer photo with the total amount visible.");
      setAiResult(parsed);

    } catch(e){
      setAiResult({error:e.message||"Could not parse receipt. Try a clearer photo or use manual entry below."});
    }
    setAiLoading(false);
  },[invoices]);
  const addFromAI=()=>{
    if(!aiResult||aiResult.error)return;
    setInvoices(p=>[{id:Date.now(),vendor:aiResult.vendor,cat:aiResult.cat,amt:aiResult.amt||0,mo:aiResult.mo,yr:aiResult.yr,st:aiResult.flag?"flagged":"confirmed",rec:aiResult.rec||false},...p]);
    setAiResult(null);
    setAiLoading(false);
    if(fileRef.current) fileRef.current.value="";
  };

  // Recurring bills helpers
  const addBill     = bill=>setRecurringBills(p=>[...p,{...bill,id:Date.now(),active:true}]);
  const toggleBill  = id=>setRecurringBills(p=>p.map(b=>b.id===id?{...b,active:!b.active}:b));
  const removeBill  = id=>setRecurringBills(p=>p.filter(b=>b.id!==id));
  const applyBills  = ()=>{
    const active = recurringBills.filter(b=>b.active);
    if(!active.length) return;
    const newInvs = [];
    MONTHS.forEach((_,mi)=>{
      active.forEach(b=>{
        const exists = invoices.some(i=>i.vendor===b.name&&i.mo===mi+1&&i.yr===taxYear&&i.rec);
        if(!exists) newInvs.push({id:Date.now()+Math.random(),vendor:b.name,cat:b.cat,amt:b.amt,mo:mi+1,yr:taxYear,st:"confirmed",rec:true});
      });
    });
    setInvoices(p=>[...p,...newInvs]);
    setImportMsg("✓ "+newInvs.length+" bill entries added for "+taxYear+"!");
    setTimeout(()=>setImportMsg(""),3000);
  };

  const dangerCount = alerts.filter(a=>a.type==="danger").length;
  const warnCount   = alerts.filter(a=>a.type==="warn").length;

  const TABS=[
    {id:"home",       lbl:"🏠 Home"},
    {id:"income",     lbl:"💰 Income"},
    {id:"forms1099",  lbl:"📄 1099s"+(forms1099.length>0?" ("+forms1099.length+")":"")},
    {id:"deductions", lbl:"✂️ Deductions"},
    {id:"invoices",   lbl:"🧾 Expenses"+(missing.length>0?" ⚡"+missing.length:"")},
    {id:"pandl",      lbl:"📈 P&L"},
    {id:"tax",        lbl:"🧮 Tax"},
    {id:"entity",     lbl:"🏛️ Entity"},
    {id:"payyourself",lbl:"💸 Pay Yourself"},
    {id:"checklist",  lbl:"✅ Checklist"},
    {id:"help",        lbl:"❓ Help"},

  ];

  return (
    <div style={{fontFamily:"'DM Sans',sans-serif",background:C.bg,minHeight:"100vh",color:C.navy}}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600;700;800&display=swap" rel="stylesheet"/>

      {/* ── HEADER ─────────────────────────────────────────────────────── */}
      <div style={{background:C.card,borderBottom:`1.5px solid ${C.border}`,padding:"12px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:36,height:36,background:`linear-gradient(135deg,${C.green},${C.gl})`,borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>⚖️</div>
          <div>
            <div style={{fontFamily:"'DM Serif Display',serif",fontSize:16,color:C.navy,lineHeight:1}}>Notary Tax Toolkit</div>
            <div style={{color:C.slate,fontSize:10,marginTop:1}}>All 50 States</div>
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
          <select value={taxYear} onChange={e=>{
            const yr=Number(e.target.value);
            const saved=loadSaved(yr);
            setTaxYear(yr);
            setSc(saved.stateCode||"FL");
            setUseRON(saved.useRON||false);
            setCustIP(saved.customIP||"");
            setCustRON(saved.customRON||"");
            setStreams(normalizeStreams(saved.streams));
            setStamps(saved.stamps||0);
            setHomePct(saved.homePct||10);
            setHomeTotal(saved.homeTotal||15000);
            setMileage(saved.mileage||0);
            setSoftware(saved.software||0);
            setEquipment(saved.equipment||0);
            setEducation(saved.education||0);
            setMarketing(saved.marketing||0);
            setInsurance(saved.insurance||0);
            setSupplies(saved.supplies||0);
            setInvoices(saved.invoices||[]);
            setForms1099(saved.forms1099||[]);
            setEntityType(saved.entityType||"soleprop");
            setRecurringBills(saved.recurringBills||[]);
            setMortgage(saved.mortgage||0);
            setCarPmt(saved.carPmt||0);
            setUtilities(saved.utilities||0);
            setGroceries(saved.groceries||0);
            setChildcare(saved.childcare||0);
            setSubscriptions(saved.subscriptions||0);
            setPersonalOther(saved.personalOther||0);
            // Only load year-specific checks + evergreen globals (no cross-year bleed)
            const yearChecks = Object.fromEntries(
              Object.entries(saved.checkedItems||{}).filter(([k])=>!EVERGREEN_ITEMS.has(k))
            );
            setCheckedItems({...yearChecks,...getGlobalChecks()});
          }} style={{background:C.gp,color:C.green,border:`1.5px solid ${C.green}40`,borderRadius:8,padding:"5px 10px",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif",cursor:"pointer"}}>
            {[2023,2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <SaveBadge saved={savedOK}/>
          <button onClick={()=>{setShowDataPanel(true);}} title="Save a restore code to back up your data" style={{background:C.tealp,color:C.teal,border:`1px solid ${C.teal}40`,borderRadius:20,padding:"3px 10px",fontSize:10,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>🔑 Backup</button>
          {missing.length>0&&<div onClick={()=>navigateTo("invoices")} style={{background:C.golp,color:C.gold,border:`1px solid ${C.goll}80`,borderRadius:20,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>⚡{missing.length} missing</div>}
          {dangerCount>0&&<div onClick={()=>navigateTo("alerts")} style={{background:C.redp,color:C.red,borderRadius:20,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>🔴{dangerCount}</div>}
          {warnCount>0&&<div onClick={()=>navigateTo("alerts")} style={{background:C.golp,color:C.gold,borderRadius:20,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>🔔{warnCount}</div>}
          <button onClick={()=>setDarkMode(v=>!v)} title={darkMode?"Light mode":"Dark mode"} style={{background:"none",border:"none",cursor:"pointer",fontSize:16,padding:"4px 6px",color:C.slate}}>{darkMode?"☀️":"🌙"}</button>
          <button onClick={()=>setShowMenu(v=>!v)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,padding:"4px 6px",color:C.slate}} title="Menu">⋮</button>
        </div>
      </div>
      {showMenu&&<div style={{position:"absolute",top:60,right:16,background:C.card,border:`1.5px solid ${C.border}`,borderRadius:14,boxShadow:"0 8px 32px rgba(0,0,0,.12)",zIndex:200,minWidth:200,overflow:"hidden"}}>
        {[["🏠","Home","home"],["💰","Income","income"],["📄","1099s","forms1099"],["✂️","Deductions","deductions"],["🧾","Invoices","invoices"],["📈","P&L","pandl"],["🧮","Tax","tax"],["🏛️","Entity","entity"],["💸","Pay Yourself","payyourself"],["✅","Checklist","checklist"],["⚠️","Alerts","alerts"]].map(([icon,label,id])=>(
          <button key={id} onClick={()=>navigateTo(id)} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"12px 16px",background:page===id?C.gp:"none",border:"none",borderBottom:`1px solid ${C.border}`,color:page===id?C.green:C.navy,fontFamily:"'DM Sans',sans-serif",fontSize:13,fontWeight:page===id?700:400,cursor:"pointer",textAlign:"left"}}>
            <span>{icon}</span><span>{label}</span>
          </button>
        ))}
        <button onClick={()=>{setShowMenu(false);setShowDataPanel(true);}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"12px 16px",background:"none",border:"none",color:C.teal,fontFamily:"'DM Sans',sans-serif",fontSize:13,fontWeight:400,cursor:"pointer"}}>
          💾 My Data (Backup / Restore)
        </button>
        <button onClick={()=>{setShowMenu(false);setShowReset(true);}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"12px 16px",background:"none",border:"none",color:C.red,fontFamily:"'DM Sans',sans-serif",fontSize:13,fontWeight:400,cursor:"pointer"}}>
          🗑️ Reset All Data
        </button>
      </div>}

      {/* ── TABS ───────────────────────────────────────────────────────── */}
      <div style={{background:C.card,borderBottom:`1.5px solid ${C.border}`,overflowX:"auto",display:"flex",padding:"0 14px"}}>
        {TABS.map(t=><NavBtn key={t.id} active={page===t.id} onClick={()=>setPage(t.id)}>{t.lbl}</NavBtn>)}
      </div>

      {!seenWelcome&&<WelcomeModal onDismiss={()=>setSeenWelcome(true)} onSetName={n=>{setUserName(n);}}/>}
      {showReset&&<ResetModal onConfirm={handleReset} onCancel={()=>setShowReset(false)}/>}
      {/* Backup code reminder banner - shown until dismissed */}
      {!seenHelp["backupBanner"]&&(
        <div style={{background:C.gp,borderBottom:`2px solid ${C.gold}60`,borderTop:`1px solid ${C.border}`,padding:"10px 18px",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <span style={{fontSize:14,flexShrink:0}}>🔑</span>
          <span style={{color:C.navy,fontSize:12,flex:1,lineHeight:1.5,opacity:0.85}}>
            <strong style={{color:C.gold}}>Keep your data safe:</strong> Generate a Restore Code and save it in your Notes app, iCloud, or email — so you can recover your data on any device.
          </span>
          <button onClick={()=>{setShowDataPanel(true);dismissHelp("backupBanner");}} style={{background:C.gold,color:C.navy,border:"none",borderRadius:7,padding:"5px 12px",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",flexShrink:0,whiteSpace:"nowrap"}}>Generate Code →</button>
          <button onClick={()=>dismissHelp("backupBanner")} style={{background:"none",border:"none",color:C.slate,cursor:"pointer",fontSize:16,padding:"0 4px",flexShrink:0}}>✕</button>
        </div>
      )}
      {showDataPanel&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:C.card,borderRadius:20,padding:"28px 24px",maxWidth:480,width:"100%",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <h3 style={{fontFamily:"'DM Serif Display',serif",fontSize:20,color:C.navy,margin:0}}>💾 My Data</h3>
              <button onClick={()=>setShowDataPanel(false)} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:C.slate}}>✕</button>
            </div>

            {importMsg&&<div style={{background:importMsg.startsWith("✓")?C.tealp:C.redp,color:importMsg.startsWith("✓")?C.teal:C.red,borderRadius:9,padding:"10px 14px",marginBottom:16,fontWeight:700,fontSize:13}}>{importMsg}</div>}



            <div style={{background:C.golp,borderRadius:12,padding:"14px 16px",marginBottom:16,border:`1px solid ${C.goll}60`}}>
              <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:4}}>🔑 Restore Code</div>
              <div style={{color:C.slate,fontSize:14,lineHeight:1.75,marginBottom:10}}>Generate a compact text code you can save anywhere — notes app, email, iCloud. Paste it back to restore.</div>
              <button onClick={generateRestoreCode} style={{width:"100%",background:restoreCodeCopied?C.tealp:C.goldl||C.golp,color:restoreCodeCopied?C.teal:C.gold,border:`1.5px solid ${restoreCodeCopied?C.teal:C.gold}`,borderRadius:9,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",marginBottom:10}}>
                {restoreCodeCopied?"✓ Code Copied to Clipboard!":"Generate & Copy Restore Code"}
              </button>
              <div style={{color:C.slate,fontSize:12,marginBottom:6}}>Paste a restore code here:</div>
              <div style={{display:"flex",gap:8}}>
                <input type="text" value={restoreInput} onChange={e=>setRestoreInput(e.target.value)} placeholder="Paste restore code here..." style={{flex:1,padding:"9px 12px",borderRadius:9,border:`1.5px solid ${C.border}`,fontSize:12,fontFamily:"'DM Sans',sans-serif",color:C.navy}}/>
                <button onClick={()=>applyRestoreCode(restoreInput)} style={{background:C.navy,color:"#fff",border:"none",borderRadius:9,padding:"9px 14px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>Apply</button>
              </div>
            </div>

            <div style={{background:C.tealp,borderRadius:12,padding:"14px 16px",border:`1px solid ${C.teal}30`}}>
              <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:4}}>📧 Email My Summary</div>
              <div style={{color:C.slate,fontSize:14,lineHeight:1.75,marginBottom:10}}>Opens your email app with a pre-filled tax summary for {taxYear}. Send it to yourself or your CPA.</div>
              <button onClick={()=>{emailSummary();}} style={{width:"100%",background:C.teal,color:"#fff",border:"none",borderRadius:9,padding:"11px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Open Email with Summary</button>
            </div>
          </div>
        </div>
      )}
      <div style={{maxWidth:900,margin:"0 auto",padding:"20px 16px"}}>

        {/* ── HOME ─────────────────────────────────────────────────────── */}
        {page==="home"&&(
          <div>
            {/* ── HERO SECTION — only show until dismissed ── */}
            {!seenHelp["heroSection"]&&!userName&&(
              <div style={{
                background:darkMode?"#0d2a1d":`linear-gradient(135deg,${LIGHT.navy},#1a4a3a)`,
                borderRadius:20,padding:"28px 22px",marginBottom:18,
                position:"relative",overflow:"hidden",
              }}>
                <div style={{position:"absolute",top:-20,right:-20,fontSize:120,opacity:.06,lineHeight:1}}>⚖️</div>
                <div style={{position:"relative",zIndex:1}}>
                  <div style={{fontSize:11,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase",color:"rgba(255,255,255,0.65)",marginBottom:8}}>Notary Tax Toolkit</div>
                  <div style={{fontFamily:"'DM Serif Display',serif",fontSize:26,color:"#fff",lineHeight:1.2,marginBottom:10}}>Your notary business,<br/>fully understood.</div>
                  <p style={{color:"rgba(255,255,255,0.8)",fontSize:14,lineHeight:1.7,marginBottom:16,maxWidth:460}}>Built specifically for notaries — tracks your income streams, calculates the §1402(c) stamp exemption, estimates your quarterly taxes, and tells you what you can safely pay yourself each month.</p>
                  <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:16}}>
                    {[["1","Select your state below","🗺️"],["2","Add income → Income tab","💰"],["3","Enter deductions → Deductions tab","✂️"],["4","Check your tax → Tax tab","🧮"]].map(([n,txt,icon])=>(
                      <div key={n} style={{display:"flex",alignItems:"center",gap:8,background:"rgba(255,255,255,0.1)",borderRadius:9,padding:"7px 12px",fontSize:13,color:"rgba(255,255,255,0.9)"}}>
                        <span style={{background:"rgba(255,255,255,0.2)",borderRadius:"50%",width:20,height:20,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:800,flexShrink:0}}>{n}</span>
                        <span>{icon} {txt}</span>
                      </div>
                    ))}
                  </div>
                  <button onClick={()=>dismissHelp("heroSection")} style={{background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.25)",color:"#fff",borderRadius:8,padding:"7px 16px",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Got it — hide this</button>
                </div>
              </div>
            )}
            {/* Personalized greeting */}
            {userName&&(
              <div style={{marginBottom:14,padding:"14px 18px",background:darkMode?"#0d2a1a":`linear-gradient(135deg,${LIGHT.navy},#1a4a2a)`,borderRadius:16,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                <div>
                  <div style={{color:"rgba(255,255,255,0.75)",fontSize:11,fontWeight:700,letterSpacing:1.2,textTransform:"uppercase",marginBottom:2}}>Welcome back</div>
                  <div style={{fontFamily:"'DM Serif Display',serif",fontSize:22,color:"#fff"}}>{userName} 👋</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{color:"rgba(255,255,255,0.75)",fontSize:11}}>{taxYear} Tax Year</div>
                  <div style={{color:C.gl,fontWeight:700,fontSize:13}}>{si.name}</div>
                </div>
              </div>
            )}
            <HelpBox id="home" text="Start here: (1) Select your state. (2) Choose In-Person or RON. (3) Go to Income and add your revenue streams. 💡 Tip: use ⋮ → My Data → Generate Restore Code to save a backup of your data." seen={seenHelp["home"]} onDismiss={dismissHelp}/>
            <HelpBox id="restoreCode" text="💡 Protect your data — tap ⋮ → My Data → Generate Restore Code and save it in your Notes app or iCloud. If you switch devices or clear your browser, paste the code back to restore everything instantly." seen={seenHelp["restoreCode"]} onDismiss={dismissHelp}/>
            <Card accent style={{marginBottom:18}}>
              <Hd>Your State</Hd>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
                <div>
                  <div style={{color:C.navy,fontSize:13,fontWeight:700,marginBottom:6}}>State</div>
                  <select value={sc} onChange={e=>setSc(e.target.value)} style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`1.5px solid ${C.border}`,background:C.card,color:C.navy,fontSize:13,fontFamily:"'DM Sans',sans-serif",cursor:"pointer"}}>
                    {Object.entries(SD).sort((a,b)=>a[1].name.localeCompare(b[1].name)).map(([c,s])=><option key={c} value={c}>{s.name}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{color:C.navy,fontSize:13,fontWeight:700,marginBottom:6}}>Stamp Exemption Fee Type</div>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {[["In-Person",false],["RON",true],["Both (use higher)",null]].map(([lbl,val])=>{
                      const active = val===null?(useRON==="both"):useRON===val;
                      return <button key={lbl} onClick={()=>setUseRON(val===null?"both":val)} style={{flex:1,minWidth:80,padding:"8px 6px",borderRadius:9,border:`1.5px solid ${active?C.green:C.border}`,background:active?C.gp:C.card,color:active?C.green:C.slate,fontWeight:700,fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>{lbl}</button>;
                    })}
                  </div>
                  <div style={{color:C.slate,fontSize:11,marginTop:5}}>"Both" uses your higher per-act fee for the exemption calculation.</div>
                </div>
                {/* Stamp exemption impact callout */}
                <div style={{background:C.golp,border:`1.5px solid ${C.goll}80`,borderRadius:10,padding:"10px 14px",marginTop:10}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <span style={{fontSize:15}}>⚠️</span>
                    <span style={{color:C.gold,fontWeight:700,fontSize:13}}>This selection affects your tax calculation</span>
                  </div>
                  <div style={{color:C.navy,fontSize:12,lineHeight:1.7,opacity:0.9}}>Your fee type determines the §1402c SE tax exemption — selecting the wrong option will over- or under-estimate your self-employment tax savings. RON fees are typically higher than in-person stamp fees.</div>
                  <div style={{marginTop:6,display:"flex",justifyContent:"space-between",fontSize:11}}>
                    <span style={{color:C.slate,fontSize:12}}>Current exemption est.</span>
                    <span style={{fontWeight:800,color:C.gold,fontSize:13}}>${T.stampEx>0?fmt(T.stampEx):"—"}</span>
                  </div>
                </div>
              </div>
              <div style={{background:C.gp,borderRadius:12,padding:"13px 15px",border:`1px solid ${C.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6,flexWrap:"wrap",gap:8}}>
                  <span style={{fontWeight:700,color:C.navy,fontSize:13}}>🏛️ {si.name}</span>
                  <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                    <span style={{background:si.ip?C.gp:C.golp,color:si.ip?C.green:C.gold,fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:10}}>In-Person: {si.ip?`$${si.ip}/act`:"No cap"}</span>
                    {si.ron&&<span style={{background:C.gp,color:C.green,fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:10}}>RON: ${si.ron}/act</span>}
                    <span style={{background:stTax.type==="none"?C.tealp:C.redp,color:stTax.type==="none"?C.teal:C.red,fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:10}}>State Tax: {stTax.type==="none"?"None":`${(stTax.rate*100).toFixed(1)}%`}</span>
                  </div>
                </div>
                <div style={{color:C.slate,fontSize:13,lineHeight:1.7}}>{si.note}</div>
                <div style={{marginTop:8,color:C.teal,fontSize:11,fontWeight:600}}>✓ Stamp fees may qualify for SE tax exemption — verify with your CPA</div>
                {(si.nf||si.ip===null||si.ron===null)&&(
                  <div style={{marginTop:12,display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    {(si.nf||si.ip===null)&&<div><div style={{color:C.navy,fontSize:11,fontWeight:700,marginBottom:5}}>Your in-person fee/act ($)</div><input type="number" value={custIP} onChange={e=>setCustIP(e.target.value)} placeholder="e.g. 10" style={{width:"100%",padding:"8px 11px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy}}/></div>}
                    {(si.nf||si.ron===null)&&<div><div style={{color:C.navy,fontSize:11,fontWeight:700,marginBottom:5}}>Your RON fee/act ($)</div><input type="number" value={custRON} onChange={e=>setCustRON(e.target.value)} placeholder="e.g. 25" style={{width:"100%",padding:"8px 11px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:C.navy}}/></div>}
                  </div>
                )}
              </div>
            </Card>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10,marginBottom:18}}>
              <Pill label="Annual Gross" value={`$${fmt(T.grossYr)}`} color={C.green}/>
              <Pill label="Stamp Exemption" value={`$${fmt(T.stampEx)}`} sub={`${fmt(stamps*12)} acts`} color={C.gold}/>
              <Pill label="Total Deductions" value={`$${fmt(T.totalD)}`} color={C.teal}/>
              <Pill label="Federal Tax" value={`$${fmt(T.fed)}`} sub={T.bkt+" bracket"} color={T.eff>25?C.red:C.green}/>
              <Pill label="State Tax" value={stTax.type==="none"?"$0 None":`$${fmt(T.stateTax)}`} sub={stTax.type==="none"?"No income tax":si.name} color={stTax.type==="none"?C.teal:C.red}/>
              <Pill label="SE Tax" value={`$${fmt(T.se)}`} color={C.gold}/>
              <Pill label="Total Tax" value={`$${fmt(T.total)}`} sub={`${T.eff.toFixed(1)}% eff.`} color={T.eff>30?C.red:C.green}/>
              <Pill label="Take-Home" value={`$${fmt(T.home)}`} color={C.teal}/>
            </div>
            <Card style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <div style={{fontWeight:700,fontSize:14,color:C.navy}}>📊 Income Streams</div>
                <button onClick={()=>setPage("income")} style={{background:C.gp,color:C.green,border:"none",borderRadius:8,padding:"5px 11px",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Manage →</button>
              </div>
              {streams.map(s=>{const def=STREAMS_DEF.find(d=>d.id===s.id);return(
                <div key={s.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>{def?.icon}</span><div><div style={{fontWeight:600,fontSize:12,color:C.navy}}>{def?.label}</div><div style={{color:C.slate,fontSize:11}}>{Number(streamSessions(s))} {def?.unit}s/yr · ${fmt(Number(streamAvgPerSession(s)))} avg/session</div></div></div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:C.green,fontWeight:700,fontSize:13}}>
                      ${fmt(streamYr(s))}/yr
                    </div>
                    <div style={{color:C.slate,fontSize:10}}>
                      avg ${fmt(Math.round(streamYr(s)/12))}/mo
                    </div>
                  </div>
                </div>
              );})}
            </Card>
            {missing.length>0&&<Card style={{borderColor:C.goll+"60",background:C.golp}}><div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:10}}>⚡ Missing Invoice Alerts</div>{missing.slice(0,3).map((m,i)=><Alrt key={i} type="warn" compact title={`${m.vendor} — ${m.moNames.join(", ")}`} msg={`~$${fmt(m.total)} potential missing deductions`}/>)}<button onClick={()=>setPage("invoices")} style={{background:"none",border:"none",color:C.gold,fontSize:11,fontWeight:700,cursor:"pointer",padding:0,marginTop:4}}>View all →</button></Card>}
          </div>
        )}

        {/* ── INCOME ───────────────────────────────────────────────────── */}
        {page==="income"&&(
          <div>
            <HelpBox id="income" text="Add every way you earn as a notary. Click a stream type to add it, then adjust the sliders. All streams feed directly into your tax calculation and P&L." seen={seenHelp["income"]} onDismiss={dismissHelp}/>
            <Hd sub="Add all your notary revenue sources. Each flows into your tax calculation.">Income Streams</Hd>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:18}}>
              {STREAMS_DEF.filter(d=>!streams.find(s=>s.id===d.id)).map(d=>(
                <button key={d.id} onClick={()=>addStream(d.id)} style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:9,padding:"6px 12px",fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",color:C.slate,display:"flex",alignItems:"center",gap:5}}>{d.icon} + {d.label}</button>
              ))}
            </div>
            {streams.map(s=>{
              const def=STREAMS_DEF.find(d=>d.id===s.id);
              if(!def)return null;
              const sYr=streamYr(s);
              const sSess=streamSessions(s);
              const sAvg=streamAvgPerSession(s);
              return(
                <Card key={s.id} style={{marginBottom:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontSize:22}}>{def.icon}</span>
                      <div>
                        <div style={{fontWeight:700,fontSize:14,color:C.navy}}>{def.label}</div>
                        <div style={{color:C.slate,fontSize:11}}>{sSess} {def.unit}s · ${fmt(sAvg)} avg/session</div>
                      </div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{textAlign:"right"}}>
                        <div style={{color:C.green,fontWeight:800,fontSize:16}}>${fmt(sYr)}<span style={{fontSize:11,fontWeight:500}}>/yr</span></div>
                        <div style={{color:C.slate,fontSize:10}}>avg ${fmt(Math.round(sYr/12))}/mo</div>
                      </div>
                      <button onClick={()=>removeStream(s.id)} style={{background:C.redp,border:"none",borderRadius:7,padding:"5px 9px",color:C.red,cursor:"pointer",fontSize:11,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>Remove</button>
                    </div>
                  </div>
                  <div style={{overflowX:"auto",marginBottom:def.notarial?12:0}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,minWidth:260}}>
                      <thead>
                        <tr style={{background:C.gp}}>
                          <th style={{textAlign:"left",color:C.slate,fontWeight:700,padding:"5px 6px",fontSize:10,letterSpacing:.5}}>MONTH</th>
                          <th style={{textAlign:"center",color:C.slate,fontWeight:700,padding:"5px 6px",fontSize:10}}># {def.unit}s</th>
                          <th style={{textAlign:"center",color:C.slate,fontWeight:700,padding:"5px 6px",fontSize:10}}>GROSS $</th>
                          <th style={{textAlign:"right",color:C.slate,fontWeight:700,padding:"5px 6px",fontSize:10}}>AVG/SESSION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(s.months||emptyMonths()).map((m,mi)=>{
                          const avg=m.cnt>0?Math.round((m.gross||0)/m.cnt):0;
                          return <tr key={mi} style={{borderTop:`1px solid ${C.border}`,background:mi%2===0?C.card:"transparent"}}>
                            <td style={{padding:"5px 6px",color:C.slate,fontWeight:600,fontSize:11,whiteSpace:"nowrap"}}>{MONTHS[mi]}</td>
                            <td style={{padding:"4px 5px"}}>
                              <input type="number" min={0} max={999} value={m.cnt===0?"":m.cnt} placeholder="0"
                                onChange={e=>updMonth(s.id,mi,"cnt",e.target.value)}
                                style={{width:"100%",textAlign:"center",padding:"4px 2px",borderRadius:6,border:`1.5px solid ${m.cnt>0?C.green:C.border}`,fontSize:12,color:m.cnt>0?C.green:C.slate,background:m.cnt>0?C.gp:C.card,fontFamily:"'DM Sans',sans-serif"}}/>
                            </td>
                            <td style={{padding:"4px 5px"}}>
                              <div style={{display:"flex",alignItems:"center",gap:2}}>
                                <span style={{color:C.slate,fontSize:12,flexShrink:0}}>$</span>
                                <input type="number" min={0} value={m.gross===0?"":m.gross} placeholder="0"
                                  onChange={e=>updMonth(s.id,mi,"gross",e.target.value)}
                                  style={{width:"100%",textAlign:"right",padding:"4px 2px",borderRadius:6,border:`1.5px solid ${m.gross>0?C.green:C.border}`,fontSize:12,color:m.gross>0?C.green:C.slate,background:m.gross>0?C.gp:C.card,fontFamily:"'DM Sans',sans-serif"}}/>
                              </div>
                            </td>
                            <td style={{padding:"5px 6px",textAlign:"right",color:avg>0?C.green:C.slate,fontWeight:avg>0?700:400,fontSize:12,whiteSpace:"nowrap"}}>{avg>0?`$${fmt(avg)}`:"—"}</td>
                          </tr>;
                        })}
                        <tr style={{borderTop:`2px solid ${C.border}`,background:C.gp}}>
                          <td style={{padding:"6px",fontWeight:700,color:C.navy,fontSize:11}}>TOTAL</td>
                          <td style={{padding:"6px",textAlign:"center",fontWeight:700,color:C.navy,fontSize:12}}>{sSess}</td>
                          <td style={{padding:"6px",textAlign:"right",fontWeight:800,color:C.green,fontSize:13}}>${fmt(sYr)}</td>
                          <td style={{padding:"6px",textAlign:"right",color:C.slate,fontSize:11}}>{sAvg>0?`$${fmt(sAvg)} avg`:""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {def.notarial&&(
                    <div style={{padding:"10px 12px",background:C.golp,borderRadius:9,border:`1px solid ${C.goll}50`,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                      <span style={{color:C.gold,fontSize:12,flex:1}}>⚖️ Avg notarial stamps per {def.unit} <span style={{color:C.slate,fontSize:10}}>(used for §1402c SE tax exemption)</span></span>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        <input type="number" min={0} max={20} value={s.stampsPerSession||1}
                          onChange={e=>updStream(s.id,"stampsPerSession",Math.max(0,Number(e.target.value)||0))}
                          style={{width:56,textAlign:"center",padding:"5px",borderRadius:7,border:`1.5px solid ${C.gold}`,fontSize:13,fontWeight:700,color:C.gold,background:C.card,fontFamily:"'DM Sans',sans-serif"}}/>
                        <span style={{color:C.gold,fontSize:12}}>per {def.unit}</span>
                      </div>
                      <div style={{width:"100%",display:"flex",justifyContent:"space-between",marginTop:4,fontSize:11,color:C.gold}}>
                        <span>Total acts: {sSess*(s.stampsPerSession||1)}</span>
                        <span>Est. SE exemption from {def.label}: <strong>${fmt(sSess*(s.stampsPerSession||1)*effFee)}</strong></span>
                      </div>
                    </div>
                  )}
                </Card>
              );
            })}
            <Card style={{background:C.gp,border:`1.5px solid ${C.border}`,marginBottom:14}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                <div><div style={{color:C.slate,fontSize:11}}>Avg Monthly</div><div style={{color:C.green,fontWeight:800,fontSize:20}}>${fmt(T.grossMo)}</div></div>
                <div><div style={{color:C.slate,fontSize:11}}>Annual Total</div><div style={{color:C.green,fontWeight:800,fontSize:20}}>${fmt(T.grossYr)}</div></div>
                <div><div style={{color:C.slate,fontSize:11}}>Streams</div><div style={{color:C.green,fontWeight:800,fontSize:20}}>{streams.length}</div></div>
              </div>
            </Card>
          </div>
        )}

        {/* ── 1099s ────────────────────────────────────────────────────── */}
        {page==="forms1099"&&(
          <div>
            <Hd sub="Track 1099-NECs from signing services. The IRS gets copies — your reported income must match.">1099 Income Tracker</Hd>
            {Math.abs(income1099Gap)>500&&(
              <Alrt type={income1099Gap<0?"danger":"warn"}
                title={income1099Gap<0?`1099s Exceed Reported Income by $${fmt(Math.abs(income1099Gap))}`:`Income Gap: $${fmt(income1099Gap)} Not on 1099s`}
                msg={income1099Gap<0?`Your 1099 total ($${fmt(total1099)}) is higher than reported income ($${fmt(T.grossYr)}). The IRS receives these automatically.`:`You reported $${fmt(T.grossYr)} but only $${fmt(total1099)} is on 1099s. All income is taxable whether or not you received a 1099.`}
              />
            )}
            {Math.abs(income1099Gap)<=500&&forms1099.length>0&&<Alrt type="success" title="1099s Match Reported Income" msg={`Your 1099 total ($${fmt(total1099)}) aligns with reported income ($${fmt(T.grossYr)}).`}/>}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:16}}>
              <Card accent>
                <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:14}}>➕ Add 1099-NEC</div>
                <AddForm1099 onAdd={f=>setForms1099(p=>[{...f,id:Date.now(),confirmed:true},...p])}/>
              </Card>
              <Card>
                <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:10}}>📊 Summary</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                  <div style={{background:C.gp,borderRadius:10,padding:"12px 14px",border:`1px solid ${C.border}`}}><div style={{color:C.slate,fontSize:10}}>Total 1099 Income</div><div style={{color:C.green,fontWeight:800,fontSize:20}}>${fmt(total1099)}</div><div style={{color:C.slate,fontSize:10,marginTop:2}}>{forms1099.filter(f=>f.confirmed).length} forms</div></div>
                  <div style={{background:Math.abs(income1099Gap)>500?(income1099Gap<0?C.redp:C.golp):C.tealp,borderRadius:10,padding:"12px 14px",border:`1px solid ${C.border}`}}><div style={{color:C.slate,fontSize:10}}>vs. Reported</div><div style={{color:Math.abs(income1099Gap)>500?(income1099Gap<0?C.red:C.gold):C.teal,fontWeight:800,fontSize:18}}>{income1099Gap===0?"Match":income1099Gap>0?`+$${fmt(income1099Gap)}`:`-$${fmt(Math.abs(income1099Gap))}`}</div></div>
                </div>
                <div style={{color:C.slate,fontSize:11,lineHeight:1.7,background:C.bg,borderRadius:8,padding:"10px 12px"}}><strong style={{color:C.navy}}>What is a 1099-NEC?</strong><br/>Signing services that pay you $600+ must send you one by Jan 31. The IRS gets a copy automatically. You owe tax on ALL self-employment income — even without a 1099.</div>
              </Card>
            </div>
            <Card>
              <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:12}}>📋 1099 Ledger</div>
              {forms1099.length===0&&<div style={{color:C.slate,fontSize:13,padding:"16px 0",textAlign:"center"}}>No 1099s added yet.</div>}
              {forms1099.map(f=>(
                <div key={f.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:C.bg,borderRadius:9,marginBottom:7,border:`1px solid ${C.border}`}}>
                  <div style={{width:7,height:7,borderRadius:"50%",background:f.confirmed?C.teal:C.gold,flexShrink:0}}/>
                  <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13,color:C.navy}}>{f.payer}</div><div style={{color:C.slate,fontSize:10}}>EIN: {f.ein||"—"} · Tax Year {f.year||2025}</div></div>
                  <div style={{color:C.green,fontWeight:700,fontSize:14}}>${fmt(f.box1)}</div>
                  <button onClick={()=>setForms1099(p=>p.filter(x=>x.id!==f.id))} style={{background:"none",border:"none",color:C.slate,cursor:"pointer",fontSize:15,padding:"0 3px"}}>×</button>
                </div>
              ))}
              {forms1099.length>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"10px 12px",background:C.gp,borderRadius:9,marginTop:6}}><span style={{fontWeight:700,color:C.navy}}>Total</span><span style={{fontWeight:800,color:C.green,fontSize:16}}>${fmt(total1099)}</span></div>}
            </Card>
          </div>
        )}

        {/* ── DEDUCTIONS ───────────────────────────────────────────────── */}
        {page==="deductions"&&(
          <div>
            <HelpBox id="deductions" text="Enter your actual annual amounts for each category. Use the ✏️ type button for exact numbers. The running total at the top updates as you go — every dollar here reduces what you owe." seen={seenHelp["deductions"]} onDismiss={dismissHelp}/>
            <Hd sub="Every dollar here reduces your taxable income.">Deductions</Hd>
            <div style={{background:C.gp,borderRadius:12,padding:"11px 16px",marginBottom:18,display:"flex",justifyContent:"space-between",alignItems:"center",border:`1px solid ${C.border}`}}><span style={{fontWeight:700,color:C.navy,fontSize:13}}>Running Total</span><span style={{color:C.green,fontWeight:800,fontSize:20}}>${fmt(T.totalD)}</span></div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🏠 Home Office</div><Slider label="% Used for Business" min={5} max={50} step={1} value={homePct} onChange={setHomePct} prefix="" suffix="%"/><Slider label="Total Annual Home Costs" min={5000} max={120000} step={500} value={homeTotal} onChange={setHomeTotal} note="Rent + utilities + internet + property tax"/><div style={{background:C.gp,borderRadius:8,padding:"10px 12px",display:"flex",justifyContent:"space-between"}}><span style={{color:C.slate,fontSize:12}}>Deduction</span><span style={{color:C.green,fontWeight:700}}>${fmt(T.homeD)}</span></div></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🚗 Mileage</div><Slider label="Business Miles" min={0} max={50000} step={100} value={mileage} onChange={setMileage} prefix="" suffix=" mi" note={`IRS rate: $${(TAX_YEARS[taxYear]||TAX_YEARS[2025]).mileage.toFixed(3)}/mi (${taxYear})`}/><div style={{background:C.gp,borderRadius:8,padding:"10px 12px",display:"flex",justifyContent:"space-between"}}><span style={{color:C.slate,fontSize:12}}>Deduction</span><span style={{color:C.green,fontWeight:700}}>${fmt(T.mileD)}</span></div></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>💻 Software & Tech</div><Slider label="Annual Cost" min={0} max={75000} step={250} value={software} onChange={setSoftware} note="Notary software, Zoom, scheduling, Motion, platforms"/></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🖥️ Equipment <span style={{background:C.golp,color:C.gold,fontSize:9,padding:"2px 6px",borderRadius:10,fontWeight:700}}>Sec 179</span></div><Slider label="Annual Cost" min={0} max={50000} step={250} value={equipment} onChange={setEquipment} note="Webcam, printer, monitors, computer, desk, camera"/></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🎓 Education</div><Slider label="Courses & Certifications" min={0} max={30000} step={100} value={education} onChange={setEducation} note="CE, training, coaching paid, masterminds, conferences"/></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>📣 Marketing</div><Slider label="Annual Marketing" min={0} max={75000} step={250} value={marketing} onChange={setMarketing} note="Website, ads, directories, social, email tools"/></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🛡️ Insurance</div><Slider label="E&O + Business Insurance" min={0} max={15000} step={100} value={insurance} onChange={setInsurance} note="E&O, general liability, cyber, umbrella"/></Card>
              <Card><div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>📦 Supplies & Other</div><Slider label="Supplies & Misc." min={0} max={15000} step={100} value={supplies} onChange={setSupplies} note="Stamps, journals, paper, shipping, bank fees, misc."/></Card>
            </div>
            <Card style={{marginTop:14,background:C.gp,border:`1.5px solid ${C.border}`}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:8}}>
                {[["🏠 Home",T.homeD],["🚗 Mileage",T.mileD],["💻 Software",software],["🖥️ Equipment",equipment],["🎓 Education",education],["📣 Marketing",marketing],["🛡️ Insurance",insurance],["📦 Supplies",supplies]].map(([l,v])=>(
                  <div key={l} style={{background:C.card,borderRadius:9,padding:"9px 11px",border:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between"}}><span style={{color:C.slate,fontSize:11}}>{l}</span><span style={{color:C.green,fontWeight:700,fontSize:12}}>${fmt(v)}</span></div>
                ))}
              </div>
              <div style={{marginTop:12,display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 14px",background:C.card,borderRadius:10,border:`1px solid ${C.border}`}}><span style={{fontWeight:800,fontSize:15,color:C.navy}}>Total Deductions</span><span style={{fontWeight:800,fontSize:22,color:C.green,fontFamily:"'DM Serif Display',serif"}}>${fmt(T.totalD)}</span></div>
            </Card>
          </div>
        )}

        {/* ── INVOICES ─────────────────────────────────────────────────── */}
        {page==="invoices"&&(
          <div>
            <Hd sub="Upload receipts to track expenses and detect missing recurring charges.">Expense Tracker</Hd>
            {missing.length>0&&(
              <Card style={{marginBottom:16,borderColor:C.goll+"60",background:C.golp}}>
                <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:10}}>⚡ Trend-Based Missing Invoice Alerts</div>
                {missing.map((m,i)=><Alrt key={i} type="warn" title={`${m.vendor} — Missing: ${m.moNames.join(", ")}`} msg={`Expected ~$${fmtD(m.avg)}/mo. Potential lost deduction: $${fmt(m.total)}.`}/>)}
              </Card>
            )}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:16}}>
              <Card accent>
                <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:12}}>📤 Upload Receipt</div>
                <div
                  onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor=C.green;}}
                  onDragLeave={e=>{e.currentTarget.style.borderColor=C.green+"55";}}
                  onDrop={e=>{e.preventDefault();e.currentTarget.style.borderColor=C.green+"55";handleFile(e.dataTransfer.files[0]);}}
                  onClick={()=>fileRef.current.click()}
                  style={{border:`2px dashed ${C.green}55`,borderRadius:12,padding:"24px 14px",textAlign:"center",cursor:"pointer",background:C.gp,marginBottom:12,transition:"border-color .2s"}}
                >
                  <div style={{fontSize:32,marginBottom:8}}>📎</div>
                  <div style={{color:C.green,fontWeight:700,fontSize:14}}>Tap to upload a receipt</div>
                  <div style={{color:C.slate,fontSize:12,marginTop:5,lineHeight:1.6}}>JPG · PNG · PDF · HEIC (iPhone)<br/>Drag & drop or tap · Max 4.5MB</div>
                </div>
                <input ref={fileRef} type="file" accept="image/*,.pdf,.heic,.heif" style={{display:"none"}} onChange={e=>{if(e.target.files[0])handleFile(e.target.files[0]);}}/>
                {aiLoading&&<div style={{textAlign:"center",color:C.green,padding:"16px 0",fontSize:13}}>⚙️ Analyzing...</div>}
                {aiResult&&!aiResult.error&&(
                  <div style={{background:C.gp,borderRadius:10,padding:13,border:`1px solid ${C.border}`}}>
                    <div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:10}}>✓ Parsed</div>
                    {[["Vendor",aiResult.vendor],["Amount",`$${fmtD(aiResult.amt||0)}`],["Category",aiResult.cat],["Month",aiResult.mo?MONTHS[aiResult.mo-1]:"—"],["Recurring",aiResult.rec?"Yes":"No"]].map(([k,v])=>(
                      <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><span style={{color:C.slate,fontSize:12}}>{k}</span><span style={{color:C.navy,fontSize:13,fontWeight:600}}>{v}</span></div>
                    ))}
                    {aiResult.flag&&<Alrt type="warn" title="Flag" msg={aiResult.flag} compact/>}
                    <button onClick={addFromAI} style={{width:"100%",background:`linear-gradient(135deg,${C.green},${C.gl})`,color:"#fff",border:"none",borderRadius:8,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",marginTop:8}}>+ Add to Ledger</button>
                  </div>
                )}
                {aiResult?.error&&<Alrt type="danger" title="Error" msg={aiResult.error}/>}
              </Card>

              {/* Manual Invoice Entry */}
              <Card style={{marginTop:0}}>
                <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:12}}>✏️ Add Manually</div>
                {(()=>{
                  const cats=["Software","Equipment","Marketing","Phone-Comm","Insurance","Education","Office","Travel","Other"];
                  return <ManualInvoiceForm onAdd={inv=>{setInvoices(p=>[{...inv,id:Date.now(),st:"confirmed"},...p]);}} cats={cats} taxYear={taxYear}/>;
                })()}
              </Card>
              <Card>
                <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:12}}>📊 Monthly Trend</div>
                <div style={{display:"flex",alignItems:"flex-end",gap:2,height:80}}>
                  {moExp.map((d,i)=>{const maxV=Math.max(...moExp.map(x=>x.tot),1);const h=d.tot>0?Math.max(4,(d.tot/maxV)*76):4;return(
                    <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                      <div title={`${d.mo}: $${fmt(d.tot)}`} style={{width:"100%",height:`${h}px`,background:d.hasMissing?`${C.red}50`:d.tot>0?`linear-gradient(180deg,${C.green},${C.gl}88)`:"#e8f0e8",borderRadius:"3px 3px 0 0",border:d.hasMissing?`1px dashed ${C.red}`:"none"}}/>
                      <span style={{color:d.hasMissing?C.red:C.slate,fontSize:8,fontWeight:d.hasMissing?700:400}}>{d.mo}</span>
                    </div>
                  );})}
                </div>
                <div style={{color:C.slate,fontSize:10,marginTop:8}}>Red dashed = missing recurring invoice</div>
                <div style={{marginTop:12}}>
                  <div style={{fontWeight:700,color:C.navy,fontSize:12,marginBottom:8}}>🔁 Recurring Vendors</div>
                  {recurring.map(v=>(
                    <div key={v.name} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${C.border}`}}>
                      <div><div style={{color:C.navy,fontSize:13,fontWeight:600}}>{v.name}</div><div style={{color:C.slate,fontSize:10}}>{v.cat} · {v.mos.length} months</div></div>
                      <div style={{textAlign:"right"}}><div style={{color:C.green,fontWeight:700,fontSize:12}}>${fmtD(v.avg)}/mo</div><div style={{color:C.slate,fontSize:10}}>${fmt(v.avg*12)}/yr</div></div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
            {/* Recurring Bills Manager */}
            <Card style={{marginBottom:14}}>
              <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:4}}>🔄 Monthly Bills</div>
              <div style={{color:C.slate,fontSize:13,marginBottom:12,lineHeight:1.7}}>Add your fixed monthly expenses here. Hit "Apply to {taxYear}" to auto-populate all 12 months at once.</div>
              {(()=>{
                const cats=["Software","Equipment","Marketing","Phone-Comm","Insurance","Education","Office","Other"];
                return <div>
                  {recurringBills.length>0&&(
                    <div style={{marginBottom:12}}>
                      {recurringBills.map(b=>(
                        <div key={b.id} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",background:b.active?C.gp:C.bg,borderRadius:9,marginBottom:6,border:`1px solid ${b.active?C.green+"40":C.border}`}}>
                          <button onClick={()=>toggleBill(b.id)} style={{width:18,height:18,borderRadius:4,border:`2px solid ${b.active?C.green:C.border}`,background:b.active?C.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",padding:0,flexShrink:0}}>
                            {b.active&&<span style={{color:"#fff",fontSize:10,fontWeight:900}}>✓</span>}
                          </button>
                          <div style={{flex:1}}><span style={{color:C.navy,fontSize:13,fontWeight:600}}>{b.name}</span><span style={{color:C.slate,fontSize:11,marginLeft:8}}>{b.cat}</span></div>
                          <span style={{color:C.green,fontWeight:700,fontSize:12}}>${fmt(b.amt)}/mo</span>
                          <button onClick={()=>removeBill(b.id)} style={{background:"none",border:"none",color:C.slate,cursor:"pointer",fontSize:14,padding:"0 2px"}}>×</button>
                        </div>
                      ))}
                      <button onClick={applyBills} style={{width:"100%",background:`linear-gradient(135deg,${C.gold},#e0a840)`,color:C.navy,border:"none",borderRadius:9,padding:"10px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",marginTop:4}}>
                        Apply All to {taxYear} (all 12 months)
                      </button>
                    </div>
                  )}
                  <AddBillForm onAdd={addBill} cats={cats}/>
                </div>;
              })()}
            </Card>

            <Card>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <div style={{fontWeight:700,color:C.navy,fontSize:13}}>📒 Expense Ledger</div>
                <div style={{display:"flex",gap:10,fontSize:10}}><span style={{color:C.teal}}>● Confirmed</span><span style={{color:C.gold}}>● Review</span><span style={{color:C.red}}>● Flagged</span></div>
              </div>
              <div style={{maxHeight:360,overflowY:"auto"}}>
                {invoices.map(inv=>{
                  const stColor={confirmed:C.teal,review:C.gold,flagged:C.red}[inv.st]||C.slate;
                  const stBg={confirmed:C.tealp,review:C.golp,flagged:C.redp}[inv.st]||C.gp;
                  const stIcon={confirmed:"✓",review:"◎",flagged:"⚑"}[inv.st]||"?";
                  // Cycle: flagged → confirmed → review → flagged
                  const nextSt={confirmed:"review",review:"flagged",flagged:"confirmed"}[inv.st]||"confirmed";
                  const nextLabel={confirmed:"→ Review",review:"→ Flagged",flagged:"→ Confirmed"}[inv.st];
                  return(
                    <div key={inv.id} style={{display:"flex",flexDirection:"column",background:C.bg,borderRadius:10,marginBottom:8,border:`1.5px solid ${inv.st==="flagged"?C.red+"50":inv.st==="review"?C.gold+"50":C.border}`,overflow:"hidden"}}>
                      <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px"}}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{color:C.navy,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inv.vendor}</div>
                          <div style={{color:C.slate,fontSize:11,marginTop:2}}>{inv.cat} · {inv.mo?MONTHS[inv.mo-1]:""} {inv.yr||""}{inv.rec?" · 🔁":""}</div>
                        </div>
                        <div style={{color:C.green,fontWeight:700,fontSize:13,flexShrink:0}}>${fmtD(inv.amt)}</div>
                        <button onClick={()=>setInvoices(p=>p.filter(i=>i.id!==inv.id))} style={{background:"none",border:"none",color:C.slate,cursor:"pointer",fontSize:16,padding:"0 2px",flexShrink:0}}>×</button>
                      </div>
                      {/* Status row — full-width tappable badge */}
                      <div style={{borderTop:`1px solid ${C.border}`,padding:"6px 12px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
                        <button
                          onClick={()=>setInvoices(p=>p.map(i=>i.id===inv.id?{...i,st:nextSt}:i))}
                          title={`Tap to change: ${nextLabel}`}
                          style={{display:"flex",alignItems:"center",gap:6,background:stBg,border:`1px solid ${stColor}40`,borderRadius:20,padding:"4px 10px",cursor:"pointer",flexShrink:0}}>
                          <span style={{color:stColor,fontSize:12,fontWeight:800}}>{stIcon}</span>
                          <span style={{color:stColor,fontSize:11,fontWeight:700,textTransform:"capitalize"}}>{inv.st}</span>
                          <span style={{color:stColor,fontSize:10,opacity:0.7}}>{nextLabel}</span>
                        </button>
                        {inv.flag&&(
                          <div style={{display:"flex",alignItems:"center",gap:6,flex:1,minWidth:0}}>
                            <span style={{color:C.gold,fontSize:11,lineHeight:1.4,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inv.flag}</span>
                            <button onClick={()=>setInvoices(p=>p.map(i=>i.id===inv.id?{...i,flag:null,st:"confirmed"}:i))} style={{background:"none",border:"none",color:C.slate,fontSize:11,cursor:"pointer",padding:0,flexShrink:0,textDecoration:"underline",whiteSpace:"nowrap"}}>dismiss</button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Year rollover button */}
              {invoices.length>0&&(
                <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
                  <button onClick={()=>setPage("invoices_rollover")} style={{width:"100%",background:C.gp,color:C.green,border:`1.5px solid ${C.green}30`,borderRadius:9,padding:"9px",fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                    📋 Copy expenses to {taxYear+1}
                  </button>
                </div>
              )}
            </Card>
          </div>
        )}

        {/* ── YEAR ROLLOVER ────────────────────────────────────────── */}
        {page==="invoices_rollover"&&(
          <RolloverPage
            invoices={invoices}
            taxYear={taxYear}
            onBack={()=>setPage("invoices")}
            onConfirm={(toAdd,nextYr)=>{
              const saved=loadSaved(nextYr);
              saveYear(nextYr,{...saved,invoices:[...(saved.invoices||[]),...toAdd]});
              setPage("invoices");
              setImportMsg(`✓ ${toAdd.length} expenses copied to ${nextYr}!`);
              setTimeout(()=>setImportMsg(""),4000);
            }}
          />
        )}

        {/* ── P&L ──────────────────────────────────────────────────────── */}
        {page==="pandl"&&(
          <div>
            <Hd sub="Your full business financials for the tax year.">Profit & Loss</Hd>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10,marginBottom:18}}>
              <Pill label="Total Revenue" value={`$${fmt(T.grossYr)}`} color={C.green}/>
              <Pill label="Total Expenses" value={`$${fmt(T.totalD)}`} color={C.gold}/>
              <Pill label="Operating Profit" value={`$${fmt(T.grossYr-T.totalD)}`} color={C.teal}/>
              <Pill label="Net Margin" value={`${T.grossYr>0?((T.grossYr-T.totalD)/T.grossYr*100).toFixed(1):0}%`} color={C.teal}/>
              <Pill label="Net After Tax" value={`$${fmt(T.home)}`} color={C.green}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Card>
                <div style={{color:C.slate,fontSize:10,fontWeight:700,letterSpacing:1.2,textTransform:"uppercase",marginBottom:14}}>Notary Business · FY {taxYear}</div>
                <PLRow label="REVENUE" bold/>
                {streams.map(s=>{const def=STREAMS_DEF.find(d=>d.id===s.id);const yr=streamSessions(s)*s.avg;return <PLRow key={s.id} label={def?.label||s.id} value={yr} indent={1}/>;})}
                <PLRow label="Total Revenue" value={T.grossYr} bold green/>
                <PLRow sep/>
                <PLRow label="OPERATING EXPENSES" bold/>
                {[["Home Office",T.homeD],["Mileage",T.mileD],["Software",software],["Equipment",equipment],["Education",education],["Marketing",marketing],["Insurance",insurance],["Supplies",supplies]].filter(([,v])=>v>0).map(([l,v])=><PLRow key={l} label={l} value={v} indent={1}/>)}
                <PLRow label="Total Expenses" value={T.totalD} bold/>
                <PLRow sep/>
                <PLRow label="Operating Profit" value={T.grossYr-T.totalD} bold green/>
                <PLRow sep/>
                <PLRow label="TAX ADJUSTMENTS" bold/>
                <PLRow label="Stamp Exemption — SE Tax Only (IRC §1402c)" value={-T.stampEx} indent={1} tag={{t:"SE Only",bg:C.gp,c:C.green}}/>
                <PLRow label="1/2 SE Tax Deduction" value={-T.seD} indent={1} green/>
                <PLRow label="Federal Taxable Income (full profit − deductions − ½SE)" value={T.fedBase} bold/>
                <PLRow sep/>
                <PLRow label={`Federal Tax (${T.bkt})`} value={T.fed} bold red/>
                <PLRow label="SE Tax (15.3%)" value={T.se} bold red/>
                <PLRow label={`${si.name} State Tax`} value={T.stateTax} bold red/>
                <PLRow sep/>
                <div style={{background:C.gp,borderRadius:10,padding:"12px 14px",marginTop:8,border:`1px solid ${C.border}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontWeight:800,fontSize:14,color:C.navy}}>NET INCOME (After-Tax)</span><span style={{fontWeight:800,fontSize:20,color:C.green,fontFamily:"'DM Serif Display',serif"}}>${fmt(T.home)}</span></div>
                </div>
              </Card>
              <div>
                <Card style={{marginBottom:14}}>
                  <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>📊 Revenue by Stream</div>
                  {streams.length===0?<div style={{color:C.slate,fontSize:13,textAlign:"center",padding:"16px 0"}}>Add income streams to see chart</div>:(
                    <svg viewBox={`0 0 300 ${Math.max(40,streams.length*44)}`} style={{width:"100%",overflow:"hidden"}}>
                      {streams.map((s,i)=>{
                        const def=STREAMS_DEF.find(d=>d.id===s.id);
                        const val=streamSessions(s)*s.avg;
                        const pct=T.grossYr>0?(val/T.grossYr)*100:0;
                        const barW=Math.max(4,Math.min(200,pct*2.0));
                        const y=i*44;
                        return <g key={s.id}>
                          <text x="0" y={y+13} fontSize="11" fill={C.slate}>{def?.icon} {def?.label}</text>
                          <rect x="0" y={y+18} width="200" height="12" rx="6" fill={C.gp}/>
                          <rect x="0" y={y+18} width={barW} height="12" rx="6" fill={C.green}/>
                          <text x="206" y={y+28} fontSize="10" fill={C.green} fontWeight="700">${fmt(val)}</text>
                        </g>;
                      })}
                    </svg>
                  )}
                </Card>
                <Card>
                  <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:14}}>🍩 Where Your Money Goes</div>
                  {T.grossYr>0?(()=>{
                    const slices=[{l:"Expenses",v:T.totalD,c:C.gold},{l:"SE Tax",v:T.se,c:"#e67e22"},{l:"Federal Tax",v:T.fed,c:C.red},{l:"State Tax",v:T.stateTax,c:"#c0392b"},{l:"Take-Home",v:T.home,c:C.green}].filter(s=>s.v>0);
                    const tot=slices.reduce((s,x)=>s+x.v,0);
                    let cum=0;
                    const cx=75,cy=75,r=60,ri=35;
                    return <div style={{display:"flex",gap:14,alignItems:"center",flexWrap:"wrap"}}>
                      <svg viewBox="0 0 150 150" style={{width:150,height:150,flexShrink:0}}>
                        {slices.map((s,i)=>{
                          const pct=s.v/tot;
                          const sa=cum*Math.PI*2-Math.PI/2;
                          cum+=pct;
                          const ea=cum*Math.PI*2-Math.PI/2;
                          const x1=cx+r*Math.cos(sa),y1=cy+r*Math.sin(sa);
                          const x2=cx+r*Math.cos(ea),y2=cy+r*Math.sin(ea);
                          const xi1=cx+ri*Math.cos(sa),yi1=cy+ri*Math.sin(sa);
                          const xi2=cx+ri*Math.cos(ea),yi2=cy+ri*Math.sin(ea);
                          const lg=pct>0.5?1:0;
                          return <path key={i} d={`M ${xi1} ${yi1} L ${x1} ${y1} A ${r} ${r} 0 ${lg} 1 ${x2} ${y2} L ${xi2} ${yi2} A ${ri} ${ri} 0 ${lg} 0 ${xi1} ${yi1}`} fill={s.c} stroke="#fff" strokeWidth="1.5"/>;
                        })}
                        <text x={cx} y={cy-5} textAnchor="middle" fontSize="8" fill={C.slate}>Total Tax</text>
                        <text x={cx} y={cy+7} textAnchor="middle" fontSize="11" fontWeight="700" fill={C.navy}>${fmt(T.total)}</text>
                      </svg>
                      <div style={{flex:1,minWidth:100}}>
                        {slices.map((s,i)=>(
                          <div key={i} style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                            <div style={{width:10,height:10,borderRadius:2,background:s.c,flexShrink:0}}/>
                            <span style={{fontSize:11,color:C.slate,flex:1}}>{s.l}</span>
                            <span style={{fontSize:11,fontWeight:700,color:s.c}}>{(s.v/tot*100).toFixed(0)}%</span>
                          </div>
                        ))}
                      </div>
                    </div>;
                  })():<div style={{color:C.slate,fontSize:13,textAlign:"center",padding:"16px 0"}}>Add income to see breakdown</div>}
                </Card>
              </div>
            </div>
          </div>
        )}

        {/* ── TAX ──────────────────────────────────────────────────────── */}
        {page==="tax"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:10}}>
      <div>
        <h2 style={{fontFamily:"'DM Serif Display',serif",fontSize:24,color:C.navy,margin:0,lineHeight:1.2}}>Tax Summary</h2>
        <p style={{color:C.slate,fontSize:13,margin:"6px 0 0",lineHeight:1.6}}>Complete federal + state tax picture for {taxYear}.</p>
      </div>
      <div style={{display:"flex",gap:8}}>
        <button onClick={copySummary} style={{background:copyDone?C.tealp:C.gp,color:copyDone?C.teal:C.green,border:`1.5px solid ${copyDone?C.teal:C.green}40`,borderRadius:9,padding:"8px 14px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
          {copyDone?"✓ Copied!":"📋 Copy Summary"}
        </button>
        <button onClick={()=>window.print()} style={{background:C.gp,color:C.green,border:`1.5px solid ${C.green}40`,borderRadius:9,padding:"8px 14px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>🖨️ Print</button>
      </div>
    </div>
            <div style={{background:darkMode?"#0d2a1d":`linear-gradient(135deg,${LIGHT.navy},#1a4a3a)`,borderRadius:20,padding:"26px 22px",color:"#fff",textAlign:"center",marginBottom:18}}>
              <div style={{fontSize:11,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase",color:"rgba(255,255,255,0.85)",marginBottom:6}}>Total Estimated Tax Burden</div>
              <div style={{fontFamily:"'DM Serif Display',serif",fontSize:48,lineHeight:1,marginBottom:6}}>${fmt(T.total)}</div>
              <div style={{fontSize:14,color:"rgba(255,255,255,0.9)",fontWeight:500}}>{T.eff.toFixed(1)}% effective rate · {T.bkt} federal bracket</div>
              <div style={{display:"flex",gap:10,justifyContent:"center",marginTop:12,flexWrap:"wrap"}}>
                {[["Federal",T.fed],["SE Tax",T.se],[`${si.name} State`,T.stateTax]].map(([lbl,val])=>(
                  <div key={lbl} style={{background:darkMode?"rgba(255,255,255,0.12)":"rgba(255,255,255,0.18)",borderRadius:10,padding:"9px 14px",textAlign:"center"}}>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.8)"}}>{lbl}</div>
                    <div style={{fontSize:18,fontWeight:800}}>{stTax.type==="none"&&lbl.includes("State")?"$0 ✓":`$${fmt(val)}`}</div>
                  </div>
                ))}
              </div>
              {T.noExSave>0&&<div style={{marginTop:14,background:darkMode?"rgba(255,255,255,0.12)":"rgba(255,255,255,0.18)",borderRadius:12,padding:"11px 14px",display:"inline-block"}}><div style={{fontSize:11,color:"rgba(255,255,255,0.8)"}}>Stamp exemption saves you ~</div><div style={{fontSize:22,fontWeight:800,fontFamily:"'DM Serif Display',serif"}}>${fmt(T.noExSave)}</div><div style={{fontSize:10,color:"rgba(255,255,255,0.6)"}}>vs. not claiming — confirm with CPA</div></div>}
            </div>
            {stTax.type!=="none"&&(
              <Card style={{marginBottom:16,borderColor:C.border}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontWeight:700,fontSize:14,color:C.navy}}>🏛️ {si.name} State Tax</div>
                  <span style={{background:C.redp,color:C.red,fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:10}}>{stTax.type==="flat"?`Flat ${(stTax.rate*100).toFixed(2)}%`:`Progressive — top ${(stTax.rate*100).toFixed(2)}%`}</span>
                </div>
                <div style={{color:C.slate,fontSize:14,marginBottom:10}}>{stTax.note}</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
                  {[["Est. State Tax",`$${fmt(T.stateTax)}`,C.red],["Std Deduction",`$${fmt(stTax.stdDed||0)}`,C.navy],["State Taxable",`$${fmt(Math.max(0,T.taxable-(stTax.stdDed||0)))}`,C.navy]].map(([l,v,col])=>(
                    <div key={l} style={{background:C.bg,borderRadius:9,padding:"10px 12px",border:`1px solid ${C.border}`}}><div style={{color:C.slate,fontSize:10}}>{l}</div><div style={{color:col,fontWeight:700,fontSize:14,marginTop:2}}>{v}</div></div>
                  ))}
                </div>
                <div style={{marginTop:10,color:C.gold,fontSize:11,background:C.golp,borderRadius:8,padding:"8px 12px"}}>State tax is simplified — local taxes, credits, and deductions vary. Verify with your CPA or state revenue dept.</div>
              </Card>
            )}
            <div style={{marginBottom:18}}>
              <div style={{fontWeight:700,fontSize:14,color:C.navy,marginBottom:12}}>📅 Quarterly Payments (Fed + State Combined)</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10}}>
                {[["Q1",`Apr 15, ${taxYear+1}`],["Q2",`Jun 16, ${taxYear+1}`],["Q3",`Sep 15, ${taxYear+1}`],["Q4",`Jan 15, ${taxYear+2}`]].map(([q,d])=>(
                  <div key={q} style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"13px 10px",textAlign:"center"}}>
                    <div style={{color:C.slate,fontSize:10,fontWeight:700,letterSpacing:1,textTransform:"uppercase"}}>{q}</div>
                    <div style={{color:C.green,fontSize:17,fontWeight:800,fontFamily:"'DM Serif Display',serif",marginTop:4}}>${fmt(T.qtr)}</div>
                    <div style={{color:C.slate,fontSize:10,marginTop:3}}>{d}</div>
                  </div>
                ))}
              </div>
              <div style={{marginTop:10,background:C.golp,border:`1px solid ${C.goll}60`,borderRadius:10,padding:"10px 14px",color:C.gold,fontSize:12}}>Set aside <strong>${fmt(T.grossMo*T.setPct/100)}/month</strong> ({T.setPct.toFixed(0)}% of gross) for all taxes.</div>
            </div>
            <Card>
              <div style={{color:C.slate,fontSize:10,fontWeight:700,letterSpacing:1.2,textTransform:"uppercase",marginBottom:14}}>Full Tax Waterfall</div>
              <PLRow label="Gross Annual Revenue" value={T.grossYr} bold green/>
              <PLRow sep/>
              <PLRow label="SE Tax Only — Stamp Exemption (IRC §1402c)" value={-T.stampEx} indent={1} tag={{t:"SE Only",bg:C.gp,c:C.green}}/>
              <PLRow label="SE Tax Base (after exemption)" value={T.seBase} bold/>
              <PLRow sep/>
              <PLRow label="All Deductions" value={-T.totalD} indent={1} green/>
              <PLRow label="Net After Deductions" value={T.seBase} bold/>
              <PLRow sep/>
              <PLRow label="SE Tax (15.3%)" value={T.se} red indent={1}/>
              <PLRow label="1/2 SE Tax Deduction" value={-T.seD} indent={1} green/>
              <PLRow label="Federal Taxable Income (full profit − deductions − ½SE)" value={T.fedBase} bold/>
              <PLRow sep/>
              <PLRow label={`Federal Income Tax (${T.bkt})`} value={T.fed} bold red/>
              <PLRow label="Self-Employment Tax" value={T.se} bold red/>
              <PLRow label={`${si.name} State Income Tax`} value={T.stateTax} bold red/>
              <div style={{background:C.redp,borderRadius:10,padding:"12px 14px",marginTop:8,border:`1px solid ${C.red}30`,display:"flex",justifyContent:"space-between"}}><span style={{fontWeight:800,fontSize:14,color:C.navy}}>Total Tax Burden</span><span style={{fontWeight:800,fontSize:20,color:C.red,fontFamily:"'DM Serif Display',serif"}}>${fmt(T.total)}</span></div>
              <div style={{background:C.gp,borderRadius:10,padding:"12px 14px",marginTop:8,border:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between"}}><span style={{fontWeight:800,fontSize:14,color:C.navy}}>Estimated Take-Home</span><span style={{fontWeight:800,fontSize:20,color:C.green,fontFamily:"'DM Serif Display',serif"}}>${fmt(T.home)}</span></div>
            </Card>
          </div>
        )}

        {/* ── ENTITY ───────────────────────────────────────────────────── */}
        {page==="entity"&&(
          <div>
            <Hd sub="How your business structure affects SE taxes — and what to ask your CPA.">Entity & Structure</Hd>
            <div style={{display:"flex",gap:10,marginBottom:18,flexWrap:"wrap"}}>
              {Object.entries(LLC_GUIDE).map(([key,g])=>(
                <button key={key} onClick={()=>setEntityType(key)} style={{flex:1,minWidth:180,background:entityType===key?C.gp:C.card,border:`1.5px solid ${entityType===key?C.green:C.border}`,borderRadius:12,padding:"13px 14px",cursor:"pointer",fontFamily:"'DM Sans',sans-serif",textAlign:"left"}}>
                  <div style={{fontSize:20,marginBottom:5}}>{g.icon}</div>
                  <div style={{fontWeight:700,fontSize:12,color:entityType===key?C.green:C.navy,lineHeight:1.3}}>{g.label}</div>
                </button>
              ))}
            </div>
            {(()=>{
              const g=LLC_GUIDE[entityType];

              return(
                <div>
                  <Card accent style={{marginBottom:14}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><span style={{fontSize:28}}>{g.icon}</span><div><div style={{fontWeight:800,fontSize:16,color:C.navy}}>{g.label}</div><div style={{color:C.slate,fontSize:12,marginTop:2}}>{g.summary}</div></div></div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                      <div style={{background:C.gp,borderRadius:10,padding:"12px 14px",border:`1px solid ${C.border}`}}><div style={{color:C.green,fontWeight:700,fontSize:12,marginBottom:8}}>Pros</div>{g.pros.map((p,i)=><div key={i} style={{color:C.slate,fontSize:12,marginBottom:4}}>• {p}</div>)}</div>
                      <div style={{background:C.redp,borderRadius:10,padding:"12px 14px",border:`1px solid ${C.border}`}}><div style={{color:C.red,fontWeight:700,fontSize:12,marginBottom:8}}>Considerations</div>{g.cons.map((c,i)=><div key={i} style={{color:C.slate,fontSize:12,marginBottom:4}}>• {c}</div>)}</div>
                    </div>
                  </Card>
                  {entityType==="scorp"&&(
                    <Card style={{marginBottom:14,borderColor:C.gold+"60",background:C.golp}}>
                      <div style={{fontWeight:700,fontSize:14,color:C.navy,marginBottom:8}}>S-Corp Snapshot</div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                        <div style={{background:C.card,borderRadius:9,padding:"10px 12px",border:`1px solid ${C.border}`}}><div style={{color:C.slate,fontSize:10}}>Your SE Tax (current)</div><div style={{color:C.red,fontWeight:800,fontSize:15,marginTop:2}}>${fmt(T.se)}</div></div>
                        <div style={{background:C.card,borderRadius:9,padding:"10px 12px",border:`1px solid ${C.border}`}}><div style={{color:C.slate,fontSize:10}}>Est. Net Profit</div><div style={{color:C.green,fontWeight:800,fontSize:15,marginTop:2}}>${fmt(T.fedBase)}</div></div>
                      </div>
                      <div style={{color:C.gold,fontSize:12,lineHeight:1.7,background:C.card,borderRadius:8,padding:"10px 12px"}}>S-Corps generally make sense above ~$50k–$80k net profit. Your CPA will calculate your reasonable salary and exact savings. Bring the talking points below to that conversation.</div>
                    </Card>
                  )}
                  <Card>
                    <div style={{fontWeight:700,fontSize:14,color:C.navy,marginBottom:12}}>CPA Talking Points</div>
                    <div style={{color:C.slate,fontSize:12,marginBottom:12}}>Screenshot these questions for your next CPA meeting:</div>
                    {g.cpaTalking.map((q,i)=>(
                      <div key={i} style={{display:"flex",gap:10,padding:"9px 12px",background:C.bg,borderRadius:9,marginBottom:7,border:`1px solid ${C.border}`}}><span style={{color:C.green,fontWeight:800,fontSize:13,flexShrink:0}}>{i+1}.</span><span style={{color:C.navy,fontSize:13}}>{q}</span></div>
                    ))}
                    <div style={{marginTop:14,background:C.gp,borderRadius:10,padding:"12px 14px",border:`1px solid ${C.border}`,fontSize:12,color:C.slate,lineHeight:1.7}}><strong style={{color:C.navy}}>What to bring:</strong> Prior year return, income stream list, all 1099-NECs, expense records, and this tax summary. A good CPA for self-employed notaries costs $300–$800/yr and saves far more.</div>
                  </Card>
                </div>
              );
            })()}
          </div>
        )}

        {/* ── PAY YOURSELF ─────────────────────────────────────────────── */}
        {page==="payyourself"&&(()=>{
          const totalPersonal=mortgage+carPmt+utilities+groceries+childcare+subscriptions+personalOther;
          // Use months with actual income for "typical month" calc — more realistic than annual avg
          const activeMonths=T.monthlyIncome.filter(v=>v>0);
          const typicalMo=activeMonths.length>0
            ? activeMonths.reduce((a,b)=>a+b,0)/activeMonths.length
            : T.grossMo;
          const taxSetAside=(typicalMo*T.setPct)/100;
          const busExp=activeMonths.length>0 ? T.totalD/activeMonths.length : T.totalD/12;
          const avail=typicalMo-taxSetAside-busExp;
          const bizBuf=Math.max(0,avail)*0.20;
          const safePay=Math.max(0,avail-bizBuf);
          const shortfall=totalPersonal-safePay;
          const surplus=safePay-totalPersonal;
          const emFund=totalPersonal*6;
          const expRatio=safePay>0?(totalPersonal/safePay)*100:100;
          const pB=v=>Math.min(100,Math.max(0,v)).toFixed(0);
          return(
            <div>
              <Hd sub="How much should you actually pay yourself? Enter your personal expenses to find out.">Pay Yourself</Hd>
              {/* View toggle */}
              <div style={{display:"flex",gap:8,marginBottom:16}}>
                {[["annual","📊 Annual View"],["monthly","📅 Month-by-Month"]].map(([mode,lbl])=>(
                  <button key={mode} onClick={()=>setPayMode(mode)}
                    style={{flex:1,padding:"9px",borderRadius:9,border:`1.5px solid ${payMode===mode?C.green:C.border}`,background:payMode===mode?C.gp:C.card,color:payMode===mode?C.green:C.slate,fontWeight:700,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                    {lbl}
                  </button>
                ))}
              </div>
              {payMode==="monthly"&&(
                <Card style={{marginBottom:16}}>
                  <div style={{fontWeight:700,color:C.navy,fontSize:13,marginBottom:4}}>📅 Monthly Breakdown</div>
                  <div style={{color:C.slate,fontSize:13,marginBottom:12,lineHeight:1.7}}>Recommended owner pay each month = gross earned − {T.setPct.toFixed(0)}% tax set-aside − avg monthly expenses − 20% business buffer.</div>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead>
                      <tr style={{background:C.gp}}>
                        <th style={{textAlign:"left",padding:"5px 6px",color:C.slate,fontWeight:700,fontSize:11}}>MONTH</th>
                        <th style={{textAlign:"right",padding:"5px 6px",color:C.slate,fontWeight:700,fontSize:10}}>GROSS</th>
                        <th style={{textAlign:"right",padding:"5px 6px",color:C.red,fontWeight:700,fontSize:10}}>TAX ASIDE</th>
                        <th style={{textAlign:"right",padding:"5px 6px",color:C.gold,fontWeight:700,fontSize:10}}>BIZ EXP</th>
                        <th style={{textAlign:"right",padding:"5px 6px",color:C.green,fontWeight:700,fontSize:10}}>OWNER PAY</th>
                      </tr>
                    </thead>
                    <tbody>
                      {T.monthlyIncome.map((gross,mi)=>{
                        if(!gross) return <tr key={mi} style={{borderTop:`1px solid ${C.border}`,background:mi%2===0?C.card:"transparent"}}>
                          <td style={{padding:"5px 6px",color:C.slate,fontWeight:600,fontSize:11}}>{MONTHS[mi]}</td>
                          <td colSpan={4} style={{padding:"5px 6px",textAlign:"center",color:C.slate,fontSize:11}}>— no income recorded —</td>
                        </tr>;
                        const taxA=Math.round(gross*(T.setPct/100));
                        const bizE=Math.round(T.totalD/activeMonths.length);
                        const buf=Math.round(Math.max(0,gross-taxA-bizE)*0.20);
                        const owner=Math.max(0,gross-taxA-bizE-buf);
                        return <tr key={mi} style={{borderTop:`1px solid ${C.border}`,background:mi%2===0?C.card:"transparent"}}>
                          <td style={{padding:"5px 6px",color:C.slate,fontWeight:600,fontSize:11}}>{MONTHS[mi]}</td>
                          <td style={{padding:"5px 6px",textAlign:"right",color:C.navy,fontWeight:600}}>${fmt(gross)}</td>
                          <td style={{padding:"5px 6px",textAlign:"right",color:C.red,fontSize:11}}>${fmt(taxA)}</td>
                          <td style={{padding:"5px 6px",textAlign:"right",color:C.gold,fontSize:11}}>${fmt(bizE)}</td>
                          <td style={{padding:"5px 6px",textAlign:"right",color:owner>0?C.green:C.slate,fontWeight:owner>0?700:400}}>${fmt(owner)}</td>
                        </tr>;
                      })}
                      <tr style={{borderTop:`2px solid ${C.border}`,background:C.gp}}>
                        <td style={{padding:"6px",fontWeight:700,color:C.navy,fontSize:11}}>TOTAL</td>
                        <td style={{padding:"6px",textAlign:"right",fontWeight:800,color:C.green}}>${fmt(T.grossYr)}</td>
                        <td style={{padding:"6px",textAlign:"right",fontWeight:700,color:C.red}}>${fmt(Math.round(T.grossYr*(T.setPct/100)))}</td>
                        <td style={{padding:"6px",textAlign:"right",fontWeight:700,color:C.gold}}>${fmt(T.totalD)}</td>
                        <td style={{padding:"6px",textAlign:"right",fontWeight:800,color:C.green}}>${fmt(Math.round(Math.max(0,T.grossYr-T.grossYr*(T.setPct/100)-T.totalD)*0.80))}</td>
                      </tr>
                    </tbody>
                  </table>
                </Card>
              )}
              <div style={{background:darkMode?"#0d2a1d":`linear-gradient(135deg,${LIGHT.navy},#1a4a3a)`,borderRadius:20,padding:"24px 22px",color:"#fff",marginBottom:18}}>
                <div style={{fontSize:11,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase",color:"rgba(255,255,255,0.8)",marginBottom:6}}>Recommended Monthly Owner Pay</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,0.75)",marginBottom:8}}>Based on avg of {activeMonths.length>0?activeMonths.length+" month"+(activeMonths.length>1?"s":"")+" with income":"annual average"} · add more months for better accuracy</div>
                <div style={{fontFamily:"'DM Serif Display',serif",fontSize:44,lineHeight:1,marginBottom:6,color:shortfall>0?"#f87171":"#a0f0b0"}}>${fmt(safePay)}</div>
                <div style={{fontSize:12,color:"rgba(255,255,255,0.9)"}}>After taxes, business expenses, and 20% business buffer</div>
                {shortfall>0?<div style={{marginTop:12,background:"rgba(255,255,255,0.12)",borderRadius:10,padding:"10px 14px",color:"#ffcaca",fontSize:12,fontWeight:600}}>⚠️ Personal expenses (${fmt(totalPersonal)}/mo) exceed safe pay by ${fmt(shortfall)}.</div>:<div style={{marginTop:12,background:"rgba(255,255,255,0.12)",borderRadius:10,padding:"10px 14px",color:"#c0ffcc",fontSize:12,fontWeight:600}}>✓ Your income supports your expenses with ${fmt(surplus)}/mo to spare.</div>}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10,marginBottom:18}}>
                <Pill label={`Typical Month${activeMonths.length>0?" ("+activeMonths.length+"mo avg)":""}`} value={`$${fmt(Math.round(typicalMo))}`} color={C.green}/>
                <Pill label="Tax Set-Aside" value={`$${fmt(taxSetAside)}`} color={C.red}/>
                <Pill label="Business Expenses" value={`$${fmt(busExp)}`} color={C.gold}/>
                <Pill label="20% Biz Buffer" value={`$${fmt(bizBuf)}`} color={C.teal}/>
                <Pill label="Safe Owner Pay" value={`$${fmt(safePay)}`} color={C.green}/>
                <Pill label="Personal Expenses" value={`$${fmt(totalPersonal)}`} color={shortfall>0?C.red:C.slate}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:18}}>
                <Card>
                  <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:14}}>🏠 Monthly Personal Expenses</div>
                  <Slider label="Mortgage / Rent" min={0} max={5000} step={50} value={mortgage} onChange={setMortgage}/>
                  <Slider label="Car Payment(s)" min={0} max={1500} step={25} value={carPmt} onChange={setCarPmt}/>
                  <Slider label="Utilities" min={0} max={800} step={25} value={utilities} onChange={setUtilities}/>
                  <Slider label="Groceries" min={0} max={2000} step={50} value={groceries} onChange={setGroceries}/>
                  <Slider label="Childcare / School" min={0} max={3000} step={50} value={childcare} onChange={setChildcare}/>
                  <Slider label="Subscriptions / Fun" min={0} max={600} step={25} value={subscriptions} onChange={setSubscriptions}/>
                  <Slider label="Other Personal" min={0} max={2000} step={50} value={personalOther} onChange={setPersonalOther}/>
                  <div style={{background:C.bg,borderRadius:9,padding:"11px 13px",border:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between"}}><span style={{fontWeight:700,color:C.navy}}>Total Monthly Needs</span><span style={{fontWeight:800,color:shortfall>0?C.red:C.green,fontSize:16}}>${fmt(totalPersonal)}</span></div>
                </Card>
                <div>
                  <Card style={{marginBottom:14}}>
                    <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:12}}>🎯 Monthly Savings Targets</div>
                    {[["💰 Emergency Fund",safePay*0.10,`Target: $${fmt(emFund)} (6 months expenses)`,C.teal],["📈 Retirement (SEP-IRA)",safePay*0.15,"15% of owner pay — up to $70k/yr, fully deductible.",C.green],["🏦 Tax Savings Account",taxSetAside,"Already factored — keep in a separate account.",C.gold]].map(([l,v,note,col])=>(
                      <div key={l} style={{background:C.bg,borderRadius:9,padding:"10px 12px",marginBottom:8,border:`1px solid ${C.border}`}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}><span style={{color:C.navy,fontSize:13,fontWeight:600}}>{l}</span><span style={{color:col,fontWeight:800,fontSize:13}}>${fmt(v)}/mo</span></div><div style={{color:C.slate,fontSize:10,lineHeight:1.5}}>{note}</div></div>
                    ))}
                  </Card>
                  <Card>
                    <div style={{fontWeight:700,fontSize:12,color:C.navy,marginBottom:10}}>📊 Expense Ratio Health</div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><span style={{color:C.slate,fontSize:12}}>Expenses vs. Safe Pay</span><span style={{color:expRatio>90?C.red:expRatio>70?C.gold:C.green,fontWeight:700,fontSize:12}}>{pB(expRatio)}%</span></div>
                    <div style={{height:8,background:C.bg,borderRadius:4,border:`1px solid ${C.border}`,marginBottom:8}}><div style={{height:"100%",width:`${pB(expRatio)}%`,background:expRatio>90?C.red:expRatio>70?C.gold:C.green,borderRadius:4}}/></div>
                    <div style={{color:C.slate,fontSize:11,lineHeight:1.6}}>{expRatio<=50?"🟢 Excellent — strong savings potential.":expRatio<=70?"🟡 Good — keep here as income grows.":expRatio<=90?"🟠 Tight — limited savings room.":"🔴 Strained — expenses consuming most of your pay."}</div>
                  </Card>
                </div>
              </div>
              <Card style={{borderColor:C.teal+"50"}}>
                <div style={{fontWeight:800,fontSize:15,color:C.navy,marginBottom:4}}>🧬 The Science of Paying Yourself</div>
                <div style={{color:C.slate,fontSize:14,marginBottom:14}}>Why intentional owner compensation is one of the most impactful decisions you'll make.</div>
                {[
                  {icon:"🧠",title:"Separate Accounts Change Behavior",stat:"People with dedicated tax accounts are 3x more likely to meet obligations without financial stress.",detail:"Behavioral economics shows physical separation makes money far less likely to be spent. Open a dedicated tax account and auto-transfer your set-aside percentage every time you receive payment."},
                  {icon:"📊",title:"The Self-Employed 30/40/15/15 Rule",stat:"30% taxes · 40% personal · 15% savings · 15% business reinvestment.",detail:`At your income: $${fmt(T.grossMo*0.30)}/mo taxes · $${fmt(T.grossMo*0.40)}/mo personal · $${fmt(T.grossMo*0.15)}/mo savings · $${fmt(T.grossMo*0.15)}/mo reinvestment.`},
                  {icon:"💼",title:"SEP-IRA: Your Tax Superpower",stat:"Contribute up to 25% of net SE income (max $70,000 for 2026). Every dollar is deductible.",detail:`At your income, a maximum SEP-IRA could save ~$${fmt(Math.min(T.fedBase*0.25,T.sepCap)*0.22)} in federal taxes. Contributions allowed until tax filing day.`},
                  {icon:"🚨",title:"Emergency Fund: Non-Negotiable",stat:"62% of self-employed Americans have under 3 months saved. Those with 6 months report 80% less financial stress.",detail:`Your 6-month target: $${fmt(emFund)}. Saving $${fmt(Math.round(emFund/24))}/month gets you there in 2 years.`},
                  {icon:"📈",title:"Start Investing Now, Not Later",stat:"$500/month at 35 grows to ~$680k by 65. Waiting until 45 yields only ~$300k — half, with 10 fewer years.",detail:"You have no employer match. But the SEP-IRA and Solo 401(k) offer higher contribution limits than a standard 401(k). Use them aggressively every year."},
                ].map((item,i)=>(
                  <div key={i} style={{marginBottom:14,paddingBottom:14,borderBottom:i<4?`1px solid ${C.border}`:"none",display:"flex",gap:12,alignItems:"flex-start"}}>
                    <span style={{fontSize:22,flexShrink:0,marginTop:2}}>{item.icon}</span>
                    <div><div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:4}}>{item.title}</div><div style={{color:C.green,fontSize:12,fontWeight:600,marginBottom:5,lineHeight:1.5,background:C.gp,borderRadius:6,padding:"4px 9px",display:"inline-block"}}>{item.stat}</div><div style={{color:C.slate,fontSize:13,lineHeight:1.75,marginTop:4}}>{item.detail}</div></div>
                  </div>
                ))}
                <div style={{background:C.golp,borderRadius:10,padding:"11px 13px",border:`1px solid ${C.goll}60`,color:C.gold,fontSize:11,lineHeight:1.7,marginTop:4}}>For educational planning only. Consult a CFP or CPA before making investment or compensation decisions.</div>
              </Card>
            </div>
          );
        })()}

        {/* ── HELP ────────────────────────────────────────────────── */}
        {page==="help"&&(
          <div>
            <Hd sub="Everything you need to know to get the most out of Notary Tax Toolkit.">Help & Guide</Hd>

            {/* Quick links */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:20}}>
              {[
                {icon:"💰",label:"Adding Income",tab:"income"},
                {icon:"✂️",label:"Deductions",tab:"deductions"},
                {icon:"🧮",label:"Tax Summary",tab:"tax"},
                {icon:"🧾",label:"Expense Tracker",tab:"invoices"},
                {icon:"💸",label:"Pay Yourself",tab:"payyourself"},
                {icon:"✅",label:"Checklist",tab:"checklist"},
              ].map(({icon,label,tab})=>(
                <button key={tab} onClick={()=>setPage(tab)} style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"14px 10px",cursor:"pointer",fontFamily:"'DM Sans',sans-serif",textAlign:"center"}}>
                  <div style={{fontSize:24,marginBottom:6}}>{icon}</div>
                  <div style={{color:C.navy,fontSize:12,fontWeight:700}}>{label}</div>
                </button>
              ))}
            </div>

            {[
              {
                icon:"⚖️", title:"What is the §1402(c) Stamp Exemption?",
                body:`This is one of the most powerful — and most missed — tax benefits for notaries. Under IRC §1402(c), fees you earn specifically for performing notarial acts may be exempt from self-employment (SE) tax.

SE tax is 15.3% — so exempting even $5,000 in stamp fees saves you $765 in SE tax alone. The exemption does NOT reduce your federal or state income taxes, only your SE tax.

To use it: on the Home tab, select your fee type (In-Person, RON, or Both). Then on each notarial income stream in the Income tab, enter how many stamps per session you perform on average.

Important: This is a legitimate but sometimes contested provision. Always verify with your CPA before claiming it on your Schedule SE.`
              },
              {
                icon:"💰", title:"How to Enter Your Income",
                body:`Go to the Income tab and click the stream types that apply to you (RON Sessions, Loan Signing Agent, etc.). Each stream shows a table with 12 months.

For each month, enter:
• # sessions/signings — how many jobs you completed
• Gross $ — total amount you earned that month

The avg/session column calculates automatically. You don't need to fill in every month — only the ones you have data for. The tax calculation uses your actual totals.

For RON, In-Person, and LSA streams, also set the "Avg stamps per session" field — this feeds the §1402c exemption calculation.`
              },
              {
                icon:"✂️", title:"Which Deductions Can Notaries Claim?",
                body:`Common deductible expenses for notary businesses:

• Home Office — if you use a dedicated space for notary work (even a desk). Calculate: (sq ft of office ÷ sq ft of home) × annual home costs
• Mileage — business miles at the IRS rate ($0.70/mi for 2025–2026). Keep a log!
• Software — notary platforms, Zoom, scheduling tools, motion, QuickBooks
• Equipment — webcam, printer, scanner, computer, desk, ring light
• Education — CE courses, certifications, coaching, conferences
• Marketing — website, ads, directories, business cards, social tools
• E&O Insurance — errors & omissions, general liability, cyber
• Supplies — stamps, journals, paper, shipping, bank fees

All deductions reduce both your federal income tax AND your SE tax base (except the stamp exemption which only reduces SE tax).`
              },
              {
                icon:"🔑", title:"How to Back Up and Restore Your Data",
                body:`Your data is stored only on your device (browser localStorage). It does NOT sync to the cloud automatically. To protect it:

1. Go to ⋮ → My Data → Generate & Copy Restore Code
2. Paste the code into your Notes app, iCloud Notes, or email it to yourself
3. Label it something like "Notary Tax Toolkit Backup 2026"

To restore on a new device:
1. Open toolkit.notaryhero.com and enter your access token
2. Go to ⋮ → My Data → paste your restore code → tap Apply

Generate a new code any time you make significant updates. It's fast and takes 10 seconds.`
              },
              {
                icon:"📅", title:"Understanding Quarterly Estimated Taxes",
                body:`As a self-employed notary, the IRS expects you to pay taxes quarterly — not just at year-end. If you underpay, you may owe a penalty.

2026 quarterly deadlines:
• Q1 (Jan–Mar): April 15, 2026
• Q2 (Apr–May): June 16, 2026
• Q3 (Jun–Aug): September 15, 2026
• Q4 (Sep–Dec): January 15, 2027

Your quarterly payment estimate is shown on the Tax tab. Pay via IRS Direct Pay at irs.gov/payments or by mailing a check with Form 1040-ES.

Tip: Set aside your tax percentage from every deposit — don't wait until the deadline.`
              },
              {
                icon:"🏛️", title:"Sole Prop vs LLC vs S-Corp — Which Is Right for Me?",
                body:`Most notaries start as sole proprietors (no filing needed) and that's fine. Here's a quick guide:

Sole Proprietor: Simplest. Report income on Schedule C. Pay SE tax on all net profit. No separate filing fees.

Single-Member LLC: Adds liability protection. Taxed the same as sole prop by default. Costs $50–$500/yr to maintain depending on state.

S-Corporation: Can reduce SE tax by paying yourself a "reasonable salary" and taking remaining profit as a distribution (distributions aren't subject to SE tax). Generally worth considering when net profit exceeds $50,000–$80,000/yr and the tax savings exceed CPA/payroll costs (~$1,500–$2,500/yr).

Always consult a CPA before making an entity election. The Entity tab has CPA talking points to bring to that conversation.`
              },
              {
                icon:"📄", title:"What is a 1099-NEC and Why Does It Matter?",
                body:`If a signing service, title company, or other payer pays you $600 or more in a calendar year, they are required to send you a 1099-NEC form by January 31.

The IRS receives a copy of every 1099 filed. If your reported income is lower than your total 1099s, that's a red flag for the IRS.

Use the 1099s tab to track every 1099 you receive. The gap indicator shows whether your reported income matches your 1099 total.

Important: All notary income is taxable whether or not you receive a 1099. Cash jobs, direct clients, and income under $600 must also be reported.`
              },
              {
                icon:"❓", title:"Why Are My Numbers Different From My CPA's?",
                body:`This tool provides estimates for planning purposes — not a filed tax return. Differences from your CPA's numbers may be due to:

• Filing status (single, MFJ, HOH) — this tool assumes single/basic
• Other income sources (spouse's W-2, investments, rentals)
• Available credits (child tax credit, education, retirement)
• Itemized vs standard deduction analysis
• QBI deduction (§199A) — up to 20% of qualified business income
• Depreciation schedules for equipment
• Self-employed health insurance deduction

Use this tool to understand your tax picture and make quarterly payment estimates. Use your CPA to file.`
              },
            ].map((item,idx)=>(
              <Card key={idx} style={{marginBottom:14}}>
                <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
                  <div style={{fontSize:28,flexShrink:0,marginTop:2}}>{item.icon}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,color:C.navy,fontSize:14,marginBottom:8}}>{item.title}</div>
                    {item.body.split("\n").map((line,i)=>(
                      <p key={i} style={{color:C.slate,fontSize:14,lineHeight:1.75,marginBottom:line===""?6:2}}>{line||" "}</p>
                    ))}
                  </div>
                </div>
              </Card>
            ))}

            <Card style={{background:C.gp,border:`1.5px solid ${C.green}30`,marginTop:8}}>
              <div style={{fontWeight:700,color:C.navy,fontSize:14,marginBottom:8}}>⚠️ Important Disclaimer</div>
              <p style={{color:C.slate,fontSize:13,lineHeight:1.7,margin:0}}>Notary Tax Toolkit provides estimates for educational and planning purposes only. It does not constitute tax advice, legal advice, or accounting services. Always consult a licensed CPA or tax professional before filing. See our full <a href="/disclaimer.html" target="_blank" style={{color:C.green,fontWeight:700}}>Disclaimer</a> and <a href="/terms.html" target="_blank" style={{color:C.green,fontWeight:700}}>Terms of Use</a>.</p>
            </Card>
          </div>
        )}

        {/* ── CHECKLIST ────────────────────────────────────────────────── */}
        {page==="checklist"&&(()=>{
          const yr=taxYear;
          const ny=yr+1;
          const ITEMS=[
            {id:"boi1",    cat:"🏛️ FinCEN / BOI",          prio:"danger", dl:"Check formation date",          title:"File FinCEN BOI Report",                       detail:`LLCs formed before Jan 1 2024 had a Jan 1 2025 deadline. New LLCs have 90 days from formation. File at fincen.gov/boi. Penalty: up to $591/day for willful violations.`},
            {id:"boi2",    cat:"🏛️ FinCEN / BOI",          prio:"warn",   dl:"Within 30 days of any change",  title:"Update BOI if ownership or address changed",   detail:"Changes to beneficial owner info (name, address, ID) must be reported within 30 calendar days."},
            {id:"1099send",cat:"📄 1099 Obligations",       prio:"danger", dl:`Jan 31, ${ny}`,                  title:`Send 1099-NEC to contractors paid $600+ in ${yr}`,detail:`Use Track1099.com or Tax1099.com. Penalty: $60–$310 per late or incorrect form. Deadline: January 31, ${ny}.`},
            {id:"1099file",cat:"📄 1099 Obligations",       prio:"danger", dl:`Jan 31, ${ny} (e-file)`,          title:"File Copy A of 1099s with IRS",                detail:"E-file by January 31 if you have 10+ forms. The IRS matches all 1099s to recipient returns — discrepancies trigger audits."},
            {id:"w9",      cat:"📄 1099 Obligations",       prio:"info",   dl:"Before first payment",           title:"Collect W-9 from every contractor before paying",detail:"Get a signed W-9 at or before first payment. Without it you may be required to withhold 24% backup withholding."},
            {id:"q1est",   cat:"💰 Estimated Tax Payments", prio:"warn",   dl:`Apr 15, ${ny}`,                  title:`Q1 Estimated Tax (~$${fmt(T.qtr)})`,           detail:`Covers Jan–Mar ${yr} income. Pay at irs.gov/payments or mail Form 1040-ES. Underpayment penalty is ~8% annually.`},
            {id:"q2est",   cat:"💰 Estimated Tax Payments", prio:"warn",   dl:`Jun 16, ${ny}`,                  title:`Q2 Estimated Tax (~$${fmt(T.qtr)})`,           detail:`Covers April–May ${yr} income.`},
            {id:"q3est",   cat:"💰 Estimated Tax Payments", prio:"warn",   dl:`Sep 15, ${ny}`,                  title:`Q3 Estimated Tax (~$${fmt(T.qtr)})`,           detail:`Covers June–August ${yr} income.`},
            {id:"q4est",   cat:"💰 Estimated Tax Payments", prio:"warn",   dl:`Jan 15, ${ny+1}`,                title:`Q4 Estimated Tax (~$${fmt(T.qtr)})`,           detail:`Covers Sept–Dec ${yr} income.`},
            {id:"file1040",cat:"💰 Estimated Tax Payments", prio:"danger", dl:`Apr 15, ${ny}`,                  title:`File Schedule C + Form 1040 for ${yr}`,        detail:"Attach Schedule C (business profit/loss) and Schedule SE (SE tax). CPA cost is deductible."},
            {id:"ext",     cat:"💰 Estimated Tax Payments", prio:"info",   dl:`Apr 15, ${ny}`,                  title:"File extension (Form 4868) if needed",         detail:"Extends filing to October 15 — but NOT the payment deadline. Interest accrues on unpaid balance from April 15."},
            {id:"eo",      cat:"📋 Notary Compliance",      prio:"danger", dl:"Check policy anniversary",       title:"Renew E&O Insurance",                          detail:"Expired E&O disqualifies you from orders on Snapdocs, NotaryDash, and most signing services. Renew 30 days early."},
            {id:"commission",cat:"📋 Notary Compliance",    prio:"danger", dl:"Check commission card",          title:"Renew Notary Commission",                      detail:"A lapsed commission means you cannot legally notarize. Set a calendar alert 90 days before expiration."},
            {id:"bond",    cat:"📋 Notary Compliance",      prio:"warn",   dl:"Same as commission",             title:"Renew Notary Bond (if required)",              detail:"Many states require a surety bond concurrent with your commission. Check your state notary association."},
            {id:"records", cat:"📋 Notary Compliance",      prio:"info",   dl:"Ongoing",                        title:"Back up journal and RON session recordings",   detail:"RON recordings: keep minimum required period (5–10 years varies by state). Store in at least 2 locations."},
            {id:"annrpt",  cat:"🏢 Business Entity",        prio:"warn",   dl:"State-specific",                 title:"File Annual Report / Statement of Information","detail":"Most states require this annually ($25–$200). Failure can result in administrative dissolution of your LLC."},
            {id:"sep",     cat:"💼 Retirement & Savings",   prio:"info",   dl:`Apr 15, ${ny} (Oct 15 w/ext)`, title:`Make SEP-IRA contribution for ${yr}`,          detail:`Max: 25% of net SE income or $70,000 (2025), whichever is less. Every dollar reduces taxable income.`},
            {id:"reconcile",cat:"💼 Retirement & Savings",  prio:"info",   dl:`Dec 31, ${yr}`,                  title:"Reconcile business bank accounts before year-end","detail":"Fix duplicate entries, missing transactions, and misclassified expenses before tax season."},
          ];
          const cats=[...new Set(ITEMS.map(i=>i.cat))];
          const doneCount=ITEMS.filter(i=>checkedItems[i.id]).length;
          const pct=Math.round((doneCount/ITEMS.length)*100);
          const PC={danger:C.red,warn:C.gold,info:C.teal};
          const PB={danger:C.redp,warn:C.golp,info:C.tealp};
          return(
            <div>
              <Hd sub={`Key deadlines and compliance tasks for ${taxYear}. Tap any item to check it off.`}>Compliance Checklist</Hd>
            <div style={{background:C.tealp,border:`1px solid ${C.teal}30`,borderRadius:10,padding:"10px 14px",marginBottom:16,display:"flex",gap:10,alignItems:"center"}}>
              <span style={{fontSize:16,flexShrink:0}}>🔑</span>
              <div style={{flex:1,color:C.navy,fontSize:14,lineHeight:1.7,opacity:0.9}}>
                <strong>Protect your progress.</strong> Your checklist saves to this device only. 
                Use <button onClick={()=>setShowDataPanel(true)} style={{background:"none",border:"none",color:C.teal,fontWeight:700,fontSize:12,cursor:"pointer",padding:0,textDecoration:"underline"}}>⋮ → My Data → Generate Restore Code</button> to save a backup code to your Notes app or email — so you never lose your data if you switch devices or clear your browser.
              </div>
            </div>
              <Card style={{marginBottom:18}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}><div style={{fontWeight:700,color:C.navy,fontSize:14}}>{doneCount} of {ITEMS.length} complete</div><div style={{color:pct===100?C.teal:pct>50?C.green:C.gold,fontWeight:800,fontSize:16}}>{pct}%</div></div>
                <div style={{height:10,background:C.bg,borderRadius:5,border:`1px solid ${C.border}`}}><div style={{height:"100%",width:`${pct}%`,background:pct===100?C.teal:`linear-gradient(90deg,${C.green},${C.gl})`,borderRadius:5,transition:"width 0.4s"}}/></div>
                <div style={{display:"flex",gap:14,marginTop:10,fontSize:11,flexWrap:"wrap"}}><span style={{color:C.red}}>⚠️ Required</span><span style={{color:C.gold}}>🔔 Important</span><span style={{color:C.teal}}>ℹ️ Good Practice</span></div>
              </Card>
              {cats.map(cat=>(
                <div key={cat} style={{marginBottom:20}}>
                  <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:10,paddingLeft:2}}>{cat}</div>
                  {ITEMS.filter(i=>i.cat===cat).map(item=>{
                    const done=checkedItems[item.id];
                    return(
                      <div key={item.id} onClick={()=>toggleCheck(item.id)} style={{background:done?"#f0fdf4":C.card,border:`1.5px solid ${done?C.gl+"60":PC[item.prio]+"40"}`,borderLeft:`4px solid ${done?C.gl:PC[item.prio]}`,borderRadius:10,padding:"12px 14px",marginBottom:8,cursor:"pointer",transition:"all 0.2s"}}>
                        <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                          <div style={{width:20,height:20,borderRadius:5,border:`2px solid ${done?C.gl:C.border}`,background:done?C.gl:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1,transition:"all 0.2s"}}>
                            {done&&<span style={{color:"#fff",fontSize:11,fontWeight:900,lineHeight:1}}>✓</span>}
                          </div>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:done?0:5,flexWrap:"wrap"}}>
                              <span style={{fontWeight:700,fontSize:13,color:done?C.teal:C.navy,textDecoration:done?"line-through":"none",lineHeight:1.3}}>{item.title}</span>
                              <span style={{background:done?C.gp:PB[item.prio],color:done?C.teal:PC[item.prio],fontSize:9,fontWeight:700,padding:"2px 8px",borderRadius:10,flexShrink:0,whiteSpace:"nowrap"}}>{item.dl}</span>
                            </div>
                            {!done&&<div style={{color:C.slate,fontSize:11,lineHeight:1.65}}>{item.detail}</div>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
              <div style={{background:C.golp,borderRadius:12,padding:"13px 15px",border:`1px solid ${C.goll}60`,color:C.gold,fontSize:11,lineHeight:1.7}}>Deadlines shown are for {taxYear}. Some shift for weekends/federal holidays. FinCEN BOI rules are subject to ongoing litigation — verify at fincen.gov. Always confirm with a licensed CPA or attorney.</div>
            </div>
          );
        })()}

        {/* ── ALERTS ───────────────────────────────────────────────────── */}
        {page==="alerts"&&(
          <div>
            <Hd sub="Tap any alert to jump directly to the relevant section.">Alerts</Hd>
            {alerts.length===0?<Alrt type="success" title="All Clear!" msg="No issues detected with your current inputs."/>:alerts.map((a,i)=><Alrt key={i} {...a} onClick={a.tab?()=>setPage(a.tab):undefined}/>)}
            <Card style={{marginTop:18}}>
              <div style={{fontWeight:700,fontSize:13,color:C.navy,marginBottom:12}}>📅 Key Tax Dates {taxYear}/{taxYear+1}</div>
              {[
                [`Q1 Estimated Tax`,`Apr 15, ${taxYear+1}`],
                [`Q2 Estimated Tax`,`Jun 16, ${taxYear+1}`],
                [`Q3 Estimated Tax`,`Sep 15, ${taxYear+1}`],
                [`Q4 Estimated Tax`,`Jan 15, ${taxYear+2}`],
                [`Schedule C / 1040 (${taxYear})`,`Apr 15, ${taxYear+1}`],
                [`Extension Deadline`,`Oct 15, ${taxYear+1}`],
              ].map(([l,d])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                  <span style={{color:C.slate,fontSize:13}}>{l}</span>
                  <span style={{color:C.green,fontWeight:700,fontSize:13}}>{d}</span>
                </div>
              ))}
            </Card>
          </div>
        )}

      </div>

      <div style={{borderTop:`1.5px solid ${C.border}`,padding:"14px 18px",background:C.card}}>
        <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:6,marginBottom:6}}>
          <span style={{color:C.slate,fontSize:11}}>For estimation only · Consult a licensed CPA · Not tax advice</span>
          <span style={{color:C.slate,fontSize:11}}>v6 · Data saved locally · <button onClick={()=>setShowReset(true)} style={{background:"none",border:"none",color:C.slate,fontSize:11,cursor:"pointer",textDecoration:"underline",padding:0,fontFamily:"'DM Sans',sans-serif"}}>Reset data</button></span>
        </div>
        <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
          {[["Terms of Use","/terms.html"],["Privacy Policy","/privacy.html"],["Disclaimer","/disclaimer.html"],["notaryhero.com","https://notaryhero.com"]].map(([label,href])=>(
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" style={{color:C.slate,fontSize:11,textDecoration:"none",borderBottom:`1px solid ${C.border}`}}>{label}</a>
          ))}
          <span style={{color:C.slate,fontSize:11}}>© 2026 Notary Hero, LLC</span>
        </div>
      </div>
    </div>
  );
}
